import { jsx as d, jsxs as Z, Fragment as He } from "react/jsx-runtime";
import * as l from "react";
import ie, { useEffect as rn, forwardRef as Sr, useId as Fr, useRef as Ko, useImperativeHandle as Gr, useMemo as xe, useLayoutEffect as Or, useState as Mr, useContext as Kr } from "react";
import * as lt from "react-dom";
import yr from "react-dom";
const Zc = ({
  themeName: e,
  overrides: t
} = {}) => {
  rn(() => {
    e && document.documentElement.setAttribute("data-theme", e), t && Object.entries(t).forEach(([o, n]) => {
      document.documentElement.style.setProperty(o, n);
    });
  }, [e, t]);
}, ue = {
  "--ll-base-unit": "var(--ll-base-unit)",
  "--ll-color-primary": "var(--ll-color-primary)",
  "--ll-color-primary-variant1": "var(--ll-color-primary-variant1)",
  "--ll-color-background": "var(--ll-color-background)",
  "--ll-color-surface": "var(--ll-color-surface)",
  "--ll-color-surface-variant1": "var(--ll-color-surface-variant1)",
  "--ll-color-surface-variant2": "var(--ll-color-surface-variant2)",
  "--ll-color-on-primary": "var(--ll-color-on-primary)",
  "--ll-color-on-primary-variant1": "var(--ll-color-on-primary-variant1)",
  "--ll-color-on-background": "var(--ll-color-on-background)",
  "--ll-color-on-background-variant1": "var(--ll-color-on-background-variant1)",
  "--ll-color-on-surface": "var(--ll-color-on-surface)",
  "--ll-color-on-surface-variant1": "var(--ll-color-on-surface-variant1)",
  "--ll-color-placeholder": "var(--ll-color-placeholder)",
  "--ll-color-disabled": "var(--ll-color-disabled)",
  "--ll-color-border": "var(--ll-color-border)",
  "--ll-color-link": "var(--ll-color-link)",
  "--ll-sdk-title-color": "var(--ll-sdk-title-color)",
  "--ll-color-error": "var(--ll-color-error)",
  "--ll-border-radius-base-unit": "var(--ll-border-radius-base-unit)",
  "--ll-border-radius-small": "var(--ll-border-radius-small)",
  "--ll-border-radius-medium": "var(--ll-border-radius-medium)",
  "--ll-border-radius-large": "var(--ll-border-radius-large)",
  "--ll-shadow-small": "var(--ll-shadow-small)",
  "--ll-shadow-medium": "var(--ll-shadow-medium)",
  "--ll-spacing-base-unit": "var(--ll-spacing-base-unit)",
  "--ll-spacing-auto": "var(--ll-spacing-auto)",
  "--ll-spacing-xx-small": "var(--ll-spacing-xx-small)",
  "--ll-spacing-x-small": "var(--ll-spacing-x-small)",
  "--ll-spacing-small": "var(--ll-spacing-small)",
  "--ll-spacing-medium": "var(--ll-spacing-medium)",
  "--ll-spacing-large": "var(--ll-spacing-large)",
  "--ll-spacing-x-large": "var(--ll-spacing-x-large)",
  "--ll-spacing-xx-large": "var(--ll-spacing-xx-large)",
  "--ll-spacing-xxx-large": "var(--ll-spacing-xxx-large)",
  "--ll-font-family": "var(--ll-font-family)",
  "--ll-font-family-mono": "var(--ll-font-family-mono)",
  "--ll-font-size-base": "var(--ll-font-size-base)",
  "--ll-font-size-h1": "var(--ll-font-size-h1)",
  "--ll-font-size-h2": "var(--ll-font-size-h2)",
  "--ll-font-size-h3": "var(--ll-font-size-h3)",
  "--ll-font-size-h4": "var(--ll-font-size-h4)",
  "--ll-font-size-h5": "var(--ll-font-size-h5)",
  "--ll-font-size-h6": "var(--ll-font-size-h6)",
  "--ll-font-size-p": "var(--ll-font-size-p)",
  "--ll-font-size-caption-1": "var(--ll-font-size-caption-1)",
  "--ll-font-size-caption-2": "var(--ll-font-size-caption-2)",
  "--ll-font-weight-light": "var(--ll-font-weight-light)",
  "--ll-font-weight-normal": "var(--ll-font-weight-normal)",
  "--ll-font-weight-medium": "var(--ll-font-weight-medium)",
  "--ll-font-weight-semibold": "var(--ll-font-weight-semibold)",
  "--ll-font-weight-bold": "var(--ll-font-weight-bold)"
}, yo = 4, Rr = {
  colorPrimary100: "#FFFFFF",
  colorPrimary99: "#04162d",
  colorPrimary95: "#C8F9FF",
  colorPrimary90: "#87F2FF",
  colorPrimary80: "#4ED8E9",
  colorPrimary70: "#21BCCC",
  colorPrimary60: "#00A0AF",
  colorPrimary50: "#008491",
  colorPrimary40: "#006974",
  colorPrimary30: "#004F57",
  colorPrimary20: "#00363C",
  colorPrimary10: "#001F23",
  colorPrimary0: "#000000"
}, Kt = {
  colorNeutral100: "#FFFFFF",
  colorNeutral99: "#FBFDFD",
  colorNeutral95: "#EFF1F1",
  colorNeutral90: "#E0E3E3",
  colorNeutral80: "#C4C7C7",
  colorNeutral70: "#A9ACAC",
  colorNeutral60: "#8E9191",
  colorNeutral50: "#747878",
  colorNeutral40: "#5C5F5F",
  colorNeutral30: "#444747",
  colorNeutral20: "#2D3131",
  colorNeutral10: "#191C1D",
  colorNeutral0: "#000000"
}, kr = {
  colorBlue70: "#0056D3"
}, Jr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blueColors: kr,
  neutralColors: Kt,
  primaryColors: Rr
}, Symbol.toStringTag, { value: "Module" })), br = (e) => e, Ur = br({
  default: {
    ease: "easeInOut",
    duration: 0.15
  },
  defaultSlow: {
    ease: "easeInOut",
    duration: 0.4
  },
  spring: {
    type: "spring",
    duration: 0.4,
    bounce: 0.3
  }
}), xr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  transitions: Ur
}, Symbol.toStringTag, { value: "Module" })), Zr = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptopS: 1024,
  laptopL: 1440,
  desktop: 2560
}, Wr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  screenSizes: Zr
}, Symbol.toStringTag, { value: "Module" })), Wc = {
  colors: Jr,
  ...xr,
  ...Wr
}, jr = `
  whitespace-nowrap inline-flex justify-center
  rounded-md leading-3 text-ll-font-size-caption-1

  data-[size=small]:py-0.5
  data-[size=small]:px-1
  data-[size=medium]:py-1
  data-[size=medium]:px-2
  data-[size=large]:py-1.5
  data-[size=large]:px-4
  `, jc = ({
  text: e,
  size: t = "small",
  className: o,
  textColor: n = Kt.colorNeutral10,
  backgroundColor: r = Kt.colorNeutral90,
  onClick: i
}) => /* @__PURE__ */ d(
  "div",
  {
    onClick: i,
    className: `${o} ${jr}`,
    style: {
      color: `${n}`,
      backgroundColor: `${r}`
    },
    "data-size": t,
    children: e
  }
), Hr = "[&>svg]:fill-inherit", Pt = ({
  SVGElement: e,
  fill: t = `${ue["--ll-color-on-background"]}`,
  className: o,
  height: n = 24,
  width: r = 24
}) => /* @__PURE__ */ d("div", { className: `${o} ${Hr}`, style: { height: `${n}px`, width: `${r}px`, fill: t }, children: /* @__PURE__ */ d(e, {}) }), Pr = `
  m-0 mb-2
  data-[nomargin=true]:mb-0
  data-[align=left]:text-left
  data-[align=center]:text-center
  data-[align=right]:text-right
  data-[variant=h1]:text-ll-font-size-h1
  data-[variant=h2]:text-ll-font-size-h2
  data-[variant=h3]:text-ll-font-size-h3
  data-[variant=h4]:text-ll-font-size-h4
  data-[variant=h5]:text-ll-font-size-h5
  data-[variant=h6]:text-ll-font-size-h6
  data-[variant=p]:text-ll-font-size-p
  data-[variant=caption1]:text-ll-font-size-caption-1
  data-[variant=caption2]:text-ll-font-size-caption-2
  data-[texttransform=capitalize]:capitalize
  data-[texttransform=uppercase]:uppercase
  data-[texttransform=lowercase]:lowercase
  data-[texttransform=none]:normal-case
  data-[family=sans-serif]:font-sans
  data-[family=mono]:font-mono

  data-[lineclamp=none]:line-clamp-none
  data-[lineclamp=none]:whitespace-nowrap
  data-[lineclamp="1"]:line-clamp-1
  data-[lineclamp="2"]:line-clamp-2
  data-[lineclamp="3"]:line-clamp-3
  data-[lineclamp="4"]:line-clamp-4
  data-[lineclamp="5"]:line-clamp-5
  data-[lineclamp="6"]:line-clamp-g
`, se = ({
  children: e,
  variant: t = "p",
  align: o,
  color: n = "--ll-color-on-background",
  lineClamp: r,
  noMargin: i,
  lineHeight: A,
  weight: a = "normal",
  family: c = "sans-serif",
  className: s,
  textTransform: u = "none",
  letterSpacing: C,
  fontVariant: h = "initial"
}) => {
  const p = `${["caption1", "caption2", "p"].includes(t) ? "p" : t}`, g = n in ue ? ue[n] : n;
  return /* @__PURE__ */ d(
    p,
    {
      style: {
        color: `${g}`,
        fontVariant: `${h}`,
        lineHeight: A || "1.45",
        letterSpacing: `${C}`,
        fontWeight: ue[a]
      },
      className: `${s} ${Pr}`,
      "data-align": o,
      "data-variant": t,
      "data-texttransform": u,
      "data-family": c,
      "data-nomargin": i,
      "data-lineclamp": r,
      children: e
    }
  );
}, Lr = `
  font-sans
  text-ll-font-size-p
  text-ll-link
  cursor-pointer
`, Nr = `
  overflow-hidden
  text-ellipsis
`, Hc = ({ children: e, href: t, className: o, lineClamp: n, download: r }) => /* @__PURE__ */ d(
  "a",
  {
    href: t,
    target: "_blank",
    rel: "noreferrer",
    className: `${o} ${Lr} ${n ? `${Nr} line-clamp-${n}` : ""}`,
    download: r,
    children: e
  }
);
function Ro(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function An(...e) {
  return (t) => {
    let o = !1;
    const n = e.map((r) => {
      const i = Ro(r, t);
      return !o && typeof i == "function" && (o = !0), i;
    });
    if (o)
      return () => {
        for (let r = 0; r < n.length; r++) {
          const i = n[r];
          typeof i == "function" ? i() : Ro(e[r], null);
        }
      };
  };
}
function L(...e) {
  return l.useCallback(An(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Ze(e) {
  const t = /* @__PURE__ */ Tr(e), o = l.forwardRef((n, r) => {
    const { children: i, ...A } = n, a = l.Children.toArray(i), c = a.find(zr);
    if (c) {
      const s = c.props.children, u = a.map((C) => C === c ? l.Children.count(s) > 1 ? l.Children.only(null) : l.isValidElement(s) ? s.props.children : null : C);
      return /* @__PURE__ */ d(t, { ...A, ref: r, children: l.isValidElement(s) ? l.cloneElement(s, void 0, u) : null });
    }
    return /* @__PURE__ */ d(t, { ...A, ref: r, children: i });
  });
  return o.displayName = `${e}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function Tr(e) {
  const t = l.forwardRef((o, n) => {
    const { children: r, ...i } = o;
    if (l.isValidElement(r)) {
      const A = _r(r), a = Xr(i, r.props);
      return r.type !== l.Fragment && (a.ref = n ? An(n, A) : A), l.cloneElement(r, a);
    }
    return l.Children.count(r) > 1 ? l.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Vr = Symbol("radix.slottable");
function zr(e) {
  return l.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Vr;
}
function Xr(e, t) {
  const o = { ...t };
  for (const n in t) {
    const r = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? r && i ? o[n] = (...a) => {
      const c = i(...a);
      return r(...a), c;
    } : r && (o[n] = r) : n === "style" ? o[n] = { ...r, ...i } : n === "className" && (o[n] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...o };
}
function _r(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var $r = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], W = $r.reduce((e, t) => {
  const o = /* @__PURE__ */ Ze(`Primitive.${t}`), n = l.forwardRef((r, i) => {
    const { asChild: A, ...a } = r, c = A ? o : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(c, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function ei(e, t) {
  e && lt.flushSync(() => e.dispatchEvent(t));
}
var ti = "Label", an = l.forwardRef((e, t) => /* @__PURE__ */ d(
  W.label,
  {
    ...e,
    ref: t,
    onMouseDown: (o) => {
      o.target.closest("button, input, select, textarea") || (e.onMouseDown?.(o), !o.defaultPrevented && o.detail > 1 && o.preventDefault());
    }
  }
));
an.displayName = ti;
var oi = an;
const ni = `
  text-ll-font-size-p text-ll-on-background font-sans
`, ri = (e) => /* @__PURE__ */ d(oi, { className: ni, ...e }), ii = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z" })), Ai = "data:image/gif;base64,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", ai = `
  border-solid 
  border-ll-on-surface-variant1
  border-b-[transparent]
  rounded-[50%]
  inline-block
  border-box
  animate-spin

  data-[color=white]:border-white
  data-[color=white]:border-b-[transparent]

  data-[size=small]:h-4
  data-[size=small]:w-4
  data-[size=small]:border-2

  data-[size=medium]:h-6
  data-[size=medium]:w-6
  data-[size=medium]:border-4

  data-[size=large]:h-8
  data-[size=large]:w-8
  data-[size=large]:border-[6px]
`, li = "h-[90px] w-[90px] max-h-auto", ci = ({
  size: e = "medium",
  image: t,
  color: o = "default"
}) => t ? /* @__PURE__ */ d(
  "img",
  {
    src: Ai,
    alt: "Loading animation",
    width: 90,
    height: 90,
    className: li
  }
) : /* @__PURE__ */ d("div", { className: ai, "data-size": e, "data-color": o }), si = `
  group
  font-normal rounded inline-flex items-center justify-center cursor-pointer
  bg-transparent border-0 box-border h-10 py-0 px-3
  text-ll-font-size-p

  disabled:cursor-default

  data-[size=small]:h-8
  data-[size=small]:px-2
  data-[size=small]:text-ll-font-size-caption-1

  data-[size=large]:h-12
  data-[size=large]:px-4

  data-[variant=contained]:bg-ll-primary
  data-[variant=contained]:text-ll-on-primary
  data-[variant=contained]:border
  data-[variant=contained]:border-solid
  data-[variant=contained]:border-transparent
  data-[variant=contained]:hover:bg-ll-primary-variant1
  data-[variant=contained]:disabled:bg-ll-disabled
  

  data-[variant=outlined]:bg-ll-background
  data-[variant=outlined]:text-ll-primary
  data-[variant=outlined]:border
  data-[variant=outlined]:border-solid
  data-[variant=outlined]:border-ll-primary
  data-[variant=outlined]:hover:bg-ll-surface-variant1
  data-[variant=outlined]:disabled:bg-ll-disabled
  data-[variant=outlined]:disabled:text-ll-on-primary
  data-[variant=outlined]:disabled:border-ll-on-background

  data-[variant=text]:text-ll-on-background
`, gi = `
  flex items-center mr-2 ml-1
  [&>svg]:fill-current [&>svg]:h-5 [&>svg]:w-5

  group-data-[size=small]:[&>svg]:h-3
  group-data-[size=small]:[&>svg]:w-3

  group-data-[size=large]:[&>svg]:h-6
  group-data-[size=large]:[&>svg]:w-6
`, ln = ie.forwardRef(
  ({
    children: e,
    disabled: t = !1,
    onClick: o,
    variant: n = "contained",
    startAdornment: r,
    size: i = "medium",
    type: A = "button",
    isLoading: a,
    className: c,
    props: s
  }, u) => /* @__PURE__ */ d(
    "button",
    {
      "data-variant": n,
      "data-size": i,
      onClick: (h) => {
        t || o && (a || o(h));
      },
      disabled: t || a,
      className: si,
      type: A,
      ref: u,
      ...s,
      children: a ? /* @__PURE__ */ d(ci, {}) : /* @__PURE__ */ Z(He, { children: [
        r && /* @__PURE__ */ d("div", { className: gi, children: r }),
        e
      ] })
    }
  )
);
ln.displayName = "Button";
const ui = `
  flex flex-col flex-1
`, Ci = `
  border flex items-center bg-ll-background
  rounded-sm focus-within:shadow-lg
  data-[has-error=true]:border-ll-error
  data-[has-error=false]:border-ll-border
`, di = `
  border flex-1 text-ll-on-background h-[30px]
  inline-flex justify-center items-center py-0 px-2
  leading-none font-sans text-ll-font-size-h6 md:text-ll-font-size-p 
  `, mi = `
  h-full w-[20px] flex justify-center items-center mx-2
`, hi = Sr(
  ({
    name: e,
    value: t,
    label: o,
    placeholder: n,
    className: r,
    autofocus: i = !1,
    hasError: A = !1,
    adornment: a,
    onBlur: c,
    onFocus: s,
    onClear: u,
    onChange: C
  }, h) => {
    const m = Fr(), p = Ko(null), g = Ko(null);
    Gr(h, () => ({
      focus: () => {
        p?.current?.focus();
      },
      get input() {
        return p.current;
      },
      get container() {
        return g.current;
      }
    }));
    const I = xe(() => o ? /* @__PURE__ */ d(ri, { htmlFor: m, style: { lineHeight: "26px" }, children: o }) : null, [o]);
    return /* @__PURE__ */ Z("div", { className: ui, ref: g, children: [
      I,
      /* @__PURE__ */ Z("div", { className: Ci, "data-has-error": A, children: [
        a && /* @__PURE__ */ d("span", { className: mi, children: a }),
        /* @__PURE__ */ d(
          "input",
          {
            type: "text",
            className: `${r} ${di}`,
            ref: p,
            name: e,
            autoFocus: i,
            id: m,
            value: t,
            onBlur: c,
            onFocus: s,
            onChange: C,
            placeholder: n,
            style: a && { width: "-webkit-fill-available" }
          }
        ),
        u && /* @__PURE__ */ d(ln, { size: "small", variant: "text", onClick: u, children: /* @__PURE__ */ d(ii, {}) })
      ] })
    ] });
  }
);
hi.displayName = "Input";
function Ii({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ l.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
    clipRule: "evenodd"
  }));
}
const pi = /* @__PURE__ */ l.forwardRef(Ii);
function fi({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ l.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const Bi = /* @__PURE__ */ l.forwardRef(fi);
function wi({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ l.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const Ei = /* @__PURE__ */ l.forwardRef(wi);
function Qi({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ l.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
    clipRule: "evenodd"
  }));
}
const Yi = /* @__PURE__ */ l.forwardRef(Qi), qi = `
    h-5 w-5 
    group-data-[type=error]:text-red-400
    group-data-[type=warning]:text-yellow-400
    group-data-[type=success]:text-green-400
    group-data-[type=info]:text-blue-400
`, Di = `
    rounded-md p-4 group
    data-[type=error]:bg-red-50
    data-[type=warning]:bg-yellow-50
    data-[type=success]:bg-green-50
    data-[type=info]:bg-blue-50 
`, vi = `
    text-sm font-medium [overflow-wrap:anywhere] 
    group-data-[type=error]:text-red-800
    group-data-[type=warning]:text-yellow-800
    group-data-[type=success]:text-green-800
    group-data-[type=info]:text-blue-800
`, Si = `
    mt-2 text-sm [overflow-wrap:anywhere] 
    group-data-[type=error]:text-red-700
    group-data-[type=warning]:text-yellow-700
    group-data-[type=success]:text-green-700
    group-data-[type=info]:text-blue-700
`, Fi = "flex", Gi = "flex-shrink-0", Oi = "ml-3", Mi = {
  error: Yi,
  warning: Bi,
  success: pi,
  info: Ei
}, Pc = ({ title: e, message: t, type: o = "warning" }) => {
  const n = Mi[o];
  return /* @__PURE__ */ d("div", { className: Di, "data-type": o, children: /* @__PURE__ */ Z("div", { className: Fi, children: [
    /* @__PURE__ */ d("div", { className: Gi, children: /* @__PURE__ */ d(n, { className: qi, "aria-hidden": !0 }) }),
    /* @__PURE__ */ Z("div", { className: Oi, children: [
      /* @__PURE__ */ d("h3", { className: vi, children: e }),
      t && /* @__PURE__ */ d("p", { className: Si, children: t })
    ] })
  ] }) });
}, ko = {
  small: 20,
  medium: 32,
  large: 40
}, Ki = {
  small: "h-5 w-5",
  medium: "h-8 w-8",
  large: "h-10 w-10"
}, yi = (e, t, o) => {
  const n = Ki[e];
  return `
    ${o ? "scale-125" : "hover:scale-125 ease-in-out duration-150"}
    flex justify-center items-center
    border-2 border-white
    rounded-full ${n} ${t ? "shadow-sm" : "shadow-none"}
`;
}, Ri = ({
  fill: e = "#fff",
  backgroundColor: t = ue["--ll-color-primary"],
  backgroundColorHighlight: o = t,
  SVGElement: n,
  size: r = "medium",
  expandMarker: i,
  renderForPrint: A = !1
}) => /* @__PURE__ */ d(
  "div",
  {
    "data-testid": "svgInfo",
    className: yi(r, A, i),
    style: {
      background: `linear-gradient(to top, ${o}, ${t})`
    },
    children: /* @__PURE__ */ d(
      Pt,
      {
        SVGElement: n,
        fill: e,
        height: ko[r] / 1.5,
        width: ko[r] / 1.5
      }
    )
  }
), ki = "shrink-0", Lc = ({
  vertical: e = !1,
  spacing: t = "--ll-spacing-auto"
}) => (
  // Horizontal spacer (vertical false) needs parent to be display: flex 
  /* @__PURE__ */ d(
    "div",
    {
      className: ki,
      style: e ? { margin: `var(${t}) 0 0 0` } : { margin: `0 var(${t}) 0 0` }
    }
  )
), Ji = (e, t) => {
  const o = e ? `h-[${e}]` : "h-[50px]", n = t ? `w-[${t}]` : "w-full";
  return `
    ${o}
    ${n}
    flex
    rounded-lg
    animate-shimmer
    bg-gradient-to-r from-ll-surface-variant1 via-ll-surface-variant2 to-ll-surface-variant1 bg-shimmer
  `;
}, Nc = ({ height: e, width: t, className: o }) => /* @__PURE__ */ d("div", { className: `${Ji(e, t)} ${o}` });
function Jo(e, [t, o]) {
  return Math.min(o, Math.max(t, e));
}
function U(e, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(r) {
    if (e?.(r), o === !1 || !r.defaultPrevented)
      return t?.(r);
  };
}
function ct(e, t = []) {
  let o = [];
  function n(i, A) {
    const a = l.createContext(A), c = o.length;
    o = [...o, A];
    const s = (C) => {
      const { scope: h, children: m, ...p } = C, g = h?.[e]?.[c] || a, I = l.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ d(g.Provider, { value: I, children: m });
    };
    s.displayName = i + "Provider";
    function u(C, h) {
      const m = h?.[e]?.[c] || a, p = l.useContext(m);
      if (p) return p;
      if (A !== void 0) return A;
      throw new Error(`\`${C}\` must be used within \`${i}\``);
    }
    return [s, u];
  }
  const r = () => {
    const i = o.map((A) => l.createContext(A));
    return function(a) {
      const c = a?.[e] || i;
      return l.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: c } }),
        [a, c]
      );
    };
  };
  return r.scopeName = e, [n, bi(r, ...t)];
}
function bi(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const o = () => {
    const n = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(i) {
      const A = n.reduce((a, { useScope: c, scopeName: s }) => {
        const C = c(i)[`__scope${s}`];
        return { ...a, ...C };
      }, {});
      return l.useMemo(() => ({ [`__scope${t.scopeName}`]: A }), [A]);
    };
  };
  return o.scopeName = t.scopeName, o;
}
function Ui(e) {
  const t = e + "CollectionProvider", [o, n] = ct(t), [r, i] = o(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), A = (g) => {
    const { scope: I, children: f } = g, B = ie.useRef(null), w = ie.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(r, { scope: I, itemMap: w, collectionRef: B, children: f });
  };
  A.displayName = t;
  const a = e + "CollectionSlot", c = /* @__PURE__ */ Ze(a), s = ie.forwardRef(
    (g, I) => {
      const { scope: f, children: B } = g, w = i(a, f), E = L(I, w.collectionRef);
      return /* @__PURE__ */ d(c, { ref: E, children: B });
    }
  );
  s.displayName = a;
  const u = e + "CollectionItemSlot", C = "data-radix-collection-item", h = /* @__PURE__ */ Ze(u), m = ie.forwardRef(
    (g, I) => {
      const { scope: f, children: B, ...w } = g, E = ie.useRef(null), Q = L(I, E), D = i(u, f);
      return ie.useEffect(() => (D.itemMap.set(E, { ref: E, ...w }), () => void D.itemMap.delete(E))), /* @__PURE__ */ d(h, { [C]: "", ref: Q, children: B });
    }
  );
  m.displayName = u;
  function p(g) {
    const I = i(e + "CollectionConsumer", g);
    return ie.useCallback(() => {
      const B = I.collectionRef.current;
      if (!B) return [];
      const w = Array.from(B.querySelectorAll(`[${C}]`));
      return Array.from(I.itemMap.values()).sort(
        (D, Y) => w.indexOf(D.ref.current) - w.indexOf(Y.ref.current)
      );
    }, [I.collectionRef, I.itemMap]);
  }
  return [
    { Provider: A, Slot: s, ItemSlot: m },
    p,
    n
  ];
}
var xi = l.createContext(void 0);
function Zi(e) {
  const t = l.useContext(xi);
  return e || t || "ltr";
}
function Ee(e) {
  const t = l.useRef(e);
  return l.useEffect(() => {
    t.current = e;
  }), l.useMemo(() => (...o) => t.current?.(...o), []);
}
function Wi(e, t = globalThis?.document) {
  const o = Ee(e);
  l.useEffect(() => {
    const n = (r) => {
      r.key === "Escape" && o(r);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [o, t]);
}
var ji = "DismissableLayer", yt = "dismissableLayer.update", Hi = "dismissableLayer.pointerDownOutside", Pi = "dismissableLayer.focusOutside", bo, cn = l.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Lt = l.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: o = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: r,
      onFocusOutside: i,
      onInteractOutside: A,
      onDismiss: a,
      ...c
    } = e, s = l.useContext(cn), [u, C] = l.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, m] = l.useState({}), p = L(t, (Y) => C(Y)), g = Array.from(s.layers), [I] = [...s.layersWithOutsidePointerEventsDisabled].slice(-1), f = g.indexOf(I), B = u ? g.indexOf(u) : -1, w = s.layersWithOutsidePointerEventsDisabled.size > 0, E = B >= f, Q = Ti((Y) => {
      const S = Y.target, O = [...s.branches].some((M) => M.contains(S));
      !E || O || (r?.(Y), A?.(Y), Y.defaultPrevented || a?.());
    }, h), D = Vi((Y) => {
      const S = Y.target;
      [...s.branches].some((M) => M.contains(S)) || (i?.(Y), A?.(Y), Y.defaultPrevented || a?.());
    }, h);
    return Wi((Y) => {
      B === s.layers.size - 1 && (n?.(Y), !Y.defaultPrevented && a && (Y.preventDefault(), a()));
    }, h), l.useEffect(() => {
      if (u)
        return o && (s.layersWithOutsidePointerEventsDisabled.size === 0 && (bo = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), s.layersWithOutsidePointerEventsDisabled.add(u)), s.layers.add(u), Uo(), () => {
          o && s.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = bo);
        };
    }, [u, h, o, s]), l.useEffect(() => () => {
      u && (s.layers.delete(u), s.layersWithOutsidePointerEventsDisabled.delete(u), Uo());
    }, [u, s]), l.useEffect(() => {
      const Y = () => m({});
      return document.addEventListener(yt, Y), () => document.removeEventListener(yt, Y);
    }, []), /* @__PURE__ */ d(
      W.div,
      {
        ...c,
        ref: p,
        style: {
          pointerEvents: w ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: U(e.onFocusCapture, D.onFocusCapture),
        onBlurCapture: U(e.onBlurCapture, D.onBlurCapture),
        onPointerDownCapture: U(
          e.onPointerDownCapture,
          Q.onPointerDownCapture
        )
      }
    );
  }
);
Lt.displayName = ji;
var Li = "DismissableLayerBranch", Ni = l.forwardRef((e, t) => {
  const o = l.useContext(cn), n = l.useRef(null), r = L(t, n);
  return l.useEffect(() => {
    const i = n.current;
    if (i)
      return o.branches.add(i), () => {
        o.branches.delete(i);
      };
  }, [o.branches]), /* @__PURE__ */ d(W.div, { ...e, ref: r });
});
Ni.displayName = Li;
function Ti(e, t = globalThis?.document) {
  const o = Ee(e), n = l.useRef(!1), r = l.useRef(() => {
  });
  return l.useEffect(() => {
    const i = (a) => {
      if (a.target && !n.current) {
        let c = function() {
          sn(
            Hi,
            o,
            s,
            { discrete: !0 }
          );
        };
        const s = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = c, t.addEventListener("click", r.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", r.current);
      n.current = !1;
    }, A = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(A), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [t, o]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Vi(e, t = globalThis?.document) {
  const o = Ee(e), n = l.useRef(!1);
  return l.useEffect(() => {
    const r = (i) => {
      i.target && !n.current && sn(Pi, o, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, o]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Uo() {
  const e = new CustomEvent(yt);
  document.dispatchEvent(e);
}
function sn(e, t, o, { discrete: n }) {
  const r = o.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: o });
  t && r.addEventListener(e, t, { once: !0 }), n ? ei(r, i) : r.dispatchEvent(i);
}
var Yt = 0;
function gn() {
  l.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? xo()), document.body.insertAdjacentElement("beforeend", e[1] ?? xo()), Yt++, () => {
      Yt === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Yt--;
    };
  }, []);
}
function xo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var qt = "focusScope.autoFocusOnMount", Dt = "focusScope.autoFocusOnUnmount", Zo = { bubbles: !1, cancelable: !0 }, zi = "FocusScope", Nt = l.forwardRef((e, t) => {
  const {
    loop: o = !1,
    trapped: n = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i,
    ...A
  } = e, [a, c] = l.useState(null), s = Ee(r), u = Ee(i), C = l.useRef(null), h = L(t, (g) => c(g)), m = l.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  l.useEffect(() => {
    if (n) {
      let g = function(w) {
        if (m.paused || !a) return;
        const E = w.target;
        a.contains(E) ? C.current = E : ce(C.current, { select: !0 });
      }, I = function(w) {
        if (m.paused || !a) return;
        const E = w.relatedTarget;
        E !== null && (a.contains(E) || ce(C.current, { select: !0 }));
      }, f = function(w) {
        if (document.activeElement === document.body)
          for (const Q of w)
            Q.removedNodes.length > 0 && ce(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", I);
      const B = new MutationObserver(f);
      return a && B.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", I), B.disconnect();
      };
    }
  }, [n, a, m.paused]), l.useEffect(() => {
    if (a) {
      jo.add(m);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const f = new CustomEvent(qt, Zo);
        a.addEventListener(qt, s), a.dispatchEvent(f), f.defaultPrevented || (Xi(oA(un(a)), { select: !0 }), document.activeElement === g && ce(a));
      }
      return () => {
        a.removeEventListener(qt, s), setTimeout(() => {
          const f = new CustomEvent(Dt, Zo);
          a.addEventListener(Dt, u), a.dispatchEvent(f), f.defaultPrevented || ce(g ?? document.body, { select: !0 }), a.removeEventListener(Dt, u), jo.remove(m);
        }, 0);
      };
    }
  }, [a, s, u, m]);
  const p = l.useCallback(
    (g) => {
      if (!o && !n || m.paused) return;
      const I = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, f = document.activeElement;
      if (I && f) {
        const B = g.currentTarget, [w, E] = _i(B);
        w && E ? !g.shiftKey && f === E ? (g.preventDefault(), o && ce(w, { select: !0 })) : g.shiftKey && f === w && (g.preventDefault(), o && ce(E, { select: !0 })) : f === B && g.preventDefault();
      }
    },
    [o, n, m.paused]
  );
  return /* @__PURE__ */ d(W.div, { tabIndex: -1, ...A, ref: h, onKeyDown: p });
});
Nt.displayName = zi;
function Xi(e, { select: t = !1 } = {}) {
  const o = document.activeElement;
  for (const n of e)
    if (ce(n, { select: t }), document.activeElement !== o) return;
}
function _i(e) {
  const t = un(e), o = Wo(t, e), n = Wo(t.reverse(), e);
  return [o, n];
}
function un(e) {
  const t = [], o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const r = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || r ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; o.nextNode(); ) t.push(o.currentNode);
  return t;
}
function Wo(e, t) {
  for (const o of e)
    if (!$i(o, { upTo: t })) return o;
}
function $i(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function eA(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ce(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const o = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== o && eA(e) && t && e.select();
  }
}
var jo = tA();
function tA() {
  let e = [];
  return {
    add(t) {
      const o = e[0];
      t !== o && o?.pause(), e = Ho(e, t), e.unshift(t);
    },
    remove(t) {
      e = Ho(e, t), e[0]?.resume();
    }
  };
}
function Ho(e, t) {
  const o = [...e], n = o.indexOf(t);
  return n !== -1 && o.splice(n, 1), o;
}
function oA(e) {
  return e.filter((t) => t.tagName !== "A");
}
var N = globalThis?.document ? l.useLayoutEffect : () => {
}, nA = l[" useId ".trim().toString()] || (() => {
}), rA = 0;
function st(e) {
  const [t, o] = l.useState(nA());
  return N(() => {
    o((n) => n ?? String(rA++));
  }, [e]), t ? `radix-${t}` : "";
}
const iA = ["top", "right", "bottom", "left"], Ce = Math.min, z = Math.max, ot = Math.round, Ne = Math.floor, oe = (e) => ({
  x: e,
  y: e
}), AA = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, aA = {
  start: "end",
  end: "start"
};
function Rt(e, t, o) {
  return z(e, Ce(t, o));
}
function Ae(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ae(e) {
  return e.split("-")[0];
}
function ye(e) {
  return e.split("-")[1];
}
function Tt(e) {
  return e === "x" ? "y" : "x";
}
function Vt(e) {
  return e === "y" ? "height" : "width";
}
function de(e) {
  return ["top", "bottom"].includes(ae(e)) ? "y" : "x";
}
function zt(e) {
  return Tt(de(e));
}
function lA(e, t, o) {
  o === void 0 && (o = !1);
  const n = ye(e), r = zt(e), i = Vt(r);
  let A = r === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (A = nt(A)), [A, nt(A)];
}
function cA(e) {
  const t = nt(e);
  return [kt(e), t, kt(t)];
}
function kt(e) {
  return e.replace(/start|end/g, (t) => aA[t]);
}
function sA(e, t, o) {
  const n = ["left", "right"], r = ["right", "left"], i = ["top", "bottom"], A = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return o ? t ? r : n : t ? n : r;
    case "left":
    case "right":
      return t ? i : A;
    default:
      return [];
  }
}
function gA(e, t, o, n) {
  const r = ye(e);
  let i = sA(ae(e), o === "start", n);
  return r && (i = i.map((A) => A + "-" + r), t && (i = i.concat(i.map(kt)))), i;
}
function nt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => AA[t]);
}
function uA(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Cn(e) {
  return typeof e != "number" ? uA(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function rt(e) {
  const {
    x: t,
    y: o,
    width: n,
    height: r
  } = e;
  return {
    width: n,
    height: r,
    top: o,
    left: t,
    right: t + n,
    bottom: o + r,
    x: t,
    y: o
  };
}
function Po(e, t, o) {
  let {
    reference: n,
    floating: r
  } = e;
  const i = de(t), A = zt(t), a = Vt(A), c = ae(t), s = i === "y", u = n.x + n.width / 2 - r.width / 2, C = n.y + n.height / 2 - r.height / 2, h = n[a] / 2 - r[a] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: u,
        y: n.y - r.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      m = {
        x: n.x + n.width,
        y: C
      };
      break;
    case "left":
      m = {
        x: n.x - r.width,
        y: C
      };
      break;
    default:
      m = {
        x: n.x,
        y: n.y
      };
  }
  switch (ye(t)) {
    case "start":
      m[A] -= h * (o && s ? -1 : 1);
      break;
    case "end":
      m[A] += h * (o && s ? -1 : 1);
      break;
  }
  return m;
}
const CA = async (e, t, o) => {
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: A
  } = o, a = i.filter(Boolean), c = await (A.isRTL == null ? void 0 : A.isRTL(t));
  let s = await A.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: u,
    y: C
  } = Po(s, n, c), h = n, m = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: I,
      fn: f
    } = a[g], {
      x: B,
      y: w,
      data: E,
      reset: Q
    } = await f({
      x: u,
      y: C,
      initialPlacement: n,
      placement: h,
      strategy: r,
      middlewareData: m,
      rects: s,
      platform: A,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = B ?? u, C = w ?? C, m = {
      ...m,
      [I]: {
        ...m[I],
        ...E
      }
    }, Q && p <= 50 && (p++, typeof Q == "object" && (Q.placement && (h = Q.placement), Q.rects && (s = Q.rects === !0 ? await A.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : Q.rects), {
      x: u,
      y: C
    } = Po(s, h, c)), g = -1);
  }
  return {
    x: u,
    y: C,
    placement: h,
    strategy: r,
    middlewareData: m
  };
};
async function We(e, t) {
  var o;
  t === void 0 && (t = {});
  const {
    x: n,
    y: r,
    platform: i,
    rects: A,
    elements: a,
    strategy: c
  } = e, {
    boundary: s = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: C = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = Ae(t, e), p = Cn(m), I = a[h ? C === "floating" ? "reference" : "floating" : C], f = rt(await i.getClippingRect({
    element: (o = await (i.isElement == null ? void 0 : i.isElement(I))) == null || o ? I : I.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: s,
    rootBoundary: u,
    strategy: c
  })), B = C === "floating" ? {
    x: n,
    y: r,
    width: A.floating.width,
    height: A.floating.height
  } : A.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), E = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Q = rt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: B,
    offsetParent: w,
    strategy: c
  }) : B);
  return {
    top: (f.top - Q.top + p.top) / E.y,
    bottom: (Q.bottom - f.bottom + p.bottom) / E.y,
    left: (f.left - Q.left + p.left) / E.x,
    right: (Q.right - f.right + p.right) / E.x
  };
}
const dA = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: o,
      y: n,
      placement: r,
      rects: i,
      platform: A,
      elements: a,
      middlewareData: c
    } = t, {
      element: s,
      padding: u = 0
    } = Ae(e, t) || {};
    if (s == null)
      return {};
    const C = Cn(u), h = {
      x: o,
      y: n
    }, m = zt(r), p = Vt(m), g = await A.getDimensions(s), I = m === "y", f = I ? "top" : "left", B = I ? "bottom" : "right", w = I ? "clientHeight" : "clientWidth", E = i.reference[p] + i.reference[m] - h[m] - i.floating[p], Q = h[m] - i.reference[m], D = await (A.getOffsetParent == null ? void 0 : A.getOffsetParent(s));
    let Y = D ? D[w] : 0;
    (!Y || !await (A.isElement == null ? void 0 : A.isElement(D))) && (Y = a.floating[w] || i.floating[p]);
    const S = E / 2 - Q / 2, O = Y / 2 - g[p] / 2 - 1, M = Ce(C[f], O), R = Ce(C[B], O), k = M, y = Y - g[p] - R, G = Y / 2 - g[p] / 2 + S, j = Rt(k, G, y), F = !c.arrow && ye(r) != null && G !== j && i.reference[p] / 2 - (G < k ? M : R) - g[p] / 2 < 0, K = F ? G < k ? G - k : G - y : 0;
    return {
      [m]: h[m] + K,
      data: {
        [m]: j,
        centerOffset: G - j - K,
        ...F && {
          alignmentOffset: K
        }
      },
      reset: F
    };
  }
}), mA = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var o, n;
      const {
        placement: r,
        middlewareData: i,
        rects: A,
        initialPlacement: a,
        platform: c,
        elements: s
      } = t, {
        mainAxis: u = !0,
        crossAxis: C = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...I
      } = Ae(e, t);
      if ((o = i.arrow) != null && o.alignmentOffset)
        return {};
      const f = ae(r), B = de(a), w = ae(a) === a, E = await (c.isRTL == null ? void 0 : c.isRTL(s.floating)), Q = h || (w || !g ? [nt(a)] : cA(a)), D = p !== "none";
      !h && D && Q.push(...gA(a, g, p, E));
      const Y = [a, ...Q], S = await We(t, I), O = [];
      let M = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && O.push(S[f]), C) {
        const G = lA(r, A, E);
        O.push(S[G[0]], S[G[1]]);
      }
      if (M = [...M, {
        placement: r,
        overflows: O
      }], !O.every((G) => G <= 0)) {
        var R, k;
        const G = (((R = i.flip) == null ? void 0 : R.index) || 0) + 1, j = Y[G];
        if (j)
          return {
            data: {
              index: G,
              overflows: M
            },
            reset: {
              placement: j
            }
          };
        let F = (k = M.filter((K) => K.overflows[0] <= 0).sort((K, v) => K.overflows[1] - v.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!F)
          switch (m) {
            case "bestFit": {
              var y;
              const K = (y = M.filter((v) => {
                if (D) {
                  const J = de(v.placement);
                  return J === B || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  J === "y";
                }
                return !0;
              }).map((v) => [v.placement, v.overflows.filter((J) => J > 0).reduce((J, V) => J + V, 0)]).sort((v, J) => v[1] - J[1])[0]) == null ? void 0 : y[0];
              K && (F = K);
              break;
            }
            case "initialPlacement":
              F = a;
              break;
          }
        if (r !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
function Lo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function No(e) {
  return iA.some((t) => e[t] >= 0);
}
const hA = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: o
      } = t, {
        strategy: n = "referenceHidden",
        ...r
      } = Ae(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await We(t, {
            ...r,
            elementContext: "reference"
          }), A = Lo(i, o.reference);
          return {
            data: {
              referenceHiddenOffsets: A,
              referenceHidden: No(A)
            }
          };
        }
        case "escaped": {
          const i = await We(t, {
            ...r,
            altBoundary: !0
          }), A = Lo(i, o.floating);
          return {
            data: {
              escapedOffsets: A,
              escaped: No(A)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function IA(e, t) {
  const {
    placement: o,
    platform: n,
    elements: r
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(r.floating)), A = ae(o), a = ye(o), c = de(o) === "y", s = ["left", "top"].includes(A) ? -1 : 1, u = i && c ? -1 : 1, C = Ae(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: p
  } = typeof C == "number" ? {
    mainAxis: C,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: C.mainAxis || 0,
    crossAxis: C.crossAxis || 0,
    alignmentAxis: C.alignmentAxis
  };
  return a && typeof p == "number" && (m = a === "end" ? p * -1 : p), c ? {
    x: m * u,
    y: h * s
  } : {
    x: h * s,
    y: m * u
  };
}
const pA = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var o, n;
      const {
        x: r,
        y: i,
        placement: A,
        middlewareData: a
      } = t, c = await IA(t, e);
      return A === ((o = a.offset) == null ? void 0 : o.placement) && (n = a.arrow) != null && n.alignmentOffset ? {} : {
        x: r + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: A
        }
      };
    }
  };
}, fA = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: o,
        y: n,
        placement: r
      } = t, {
        mainAxis: i = !0,
        crossAxis: A = !1,
        limiter: a = {
          fn: (I) => {
            let {
              x: f,
              y: B
            } = I;
            return {
              x: f,
              y: B
            };
          }
        },
        ...c
      } = Ae(e, t), s = {
        x: o,
        y: n
      }, u = await We(t, c), C = de(ae(r)), h = Tt(C);
      let m = s[h], p = s[C];
      if (i) {
        const I = h === "y" ? "top" : "left", f = h === "y" ? "bottom" : "right", B = m + u[I], w = m - u[f];
        m = Rt(B, m, w);
      }
      if (A) {
        const I = C === "y" ? "top" : "left", f = C === "y" ? "bottom" : "right", B = p + u[I], w = p - u[f];
        p = Rt(B, p, w);
      }
      const g = a.fn({
        ...t,
        [h]: m,
        [C]: p
      });
      return {
        ...g,
        data: {
          x: g.x - o,
          y: g.y - n,
          enabled: {
            [h]: i,
            [C]: A
          }
        }
      };
    }
  };
}, BA = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: o,
        y: n,
        placement: r,
        rects: i,
        middlewareData: A
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: s = !0
      } = Ae(e, t), u = {
        x: o,
        y: n
      }, C = de(r), h = Tt(C);
      let m = u[h], p = u[C];
      const g = Ae(a, t), I = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (c) {
        const w = h === "y" ? "height" : "width", E = i.reference[h] - i.floating[w] + I.mainAxis, Q = i.reference[h] + i.reference[w] - I.mainAxis;
        m < E ? m = E : m > Q && (m = Q);
      }
      if (s) {
        var f, B;
        const w = h === "y" ? "width" : "height", E = ["top", "left"].includes(ae(r)), Q = i.reference[C] - i.floating[w] + (E && ((f = A.offset) == null ? void 0 : f[C]) || 0) + (E ? 0 : I.crossAxis), D = i.reference[C] + i.reference[w] + (E ? 0 : ((B = A.offset) == null ? void 0 : B[C]) || 0) - (E ? I.crossAxis : 0);
        p < Q ? p = Q : p > D && (p = D);
      }
      return {
        [h]: m,
        [C]: p
      };
    }
  };
}, wA = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var o, n;
      const {
        placement: r,
        rects: i,
        platform: A,
        elements: a
      } = t, {
        apply: c = () => {
        },
        ...s
      } = Ae(e, t), u = await We(t, s), C = ae(r), h = ye(r), m = de(r) === "y", {
        width: p,
        height: g
      } = i.floating;
      let I, f;
      C === "top" || C === "bottom" ? (I = C, f = h === (await (A.isRTL == null ? void 0 : A.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (f = C, I = h === "end" ? "top" : "bottom");
      const B = g - u.top - u.bottom, w = p - u.left - u.right, E = Ce(g - u[I], B), Q = Ce(p - u[f], w), D = !t.middlewareData.shift;
      let Y = E, S = Q;
      if ((o = t.middlewareData.shift) != null && o.enabled.x && (S = w), (n = t.middlewareData.shift) != null && n.enabled.y && (Y = B), D && !h) {
        const M = z(u.left, 0), R = z(u.right, 0), k = z(u.top, 0), y = z(u.bottom, 0);
        m ? S = p - 2 * (M !== 0 || R !== 0 ? M + R : z(u.left, u.right)) : Y = g - 2 * (k !== 0 || y !== 0 ? k + y : z(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: S,
        availableHeight: Y
      });
      const O = await A.getDimensions(a.floating);
      return p !== O.width || g !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function gt() {
  return typeof window < "u";
}
function Re(e) {
  return dn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function X(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function re(e) {
  var t;
  return (t = (dn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function dn(e) {
  return gt() ? e instanceof Node || e instanceof X(e).Node : !1;
}
function ee(e) {
  return gt() ? e instanceof Element || e instanceof X(e).Element : !1;
}
function ne(e) {
  return gt() ? e instanceof HTMLElement || e instanceof X(e).HTMLElement : !1;
}
function To(e) {
  return !gt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof X(e).ShadowRoot;
}
function Pe(e) {
  const {
    overflow: t,
    overflowX: o,
    overflowY: n,
    display: r
  } = te(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + o) && !["inline", "contents"].includes(r);
}
function EA(e) {
  return ["table", "td", "th"].includes(Re(e));
}
function ut(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Xt(e) {
  const t = _t(), o = ee(e) ? te(e) : e;
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !t && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !t && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (o.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (o.contain || "").includes(n));
}
function QA(e) {
  let t = me(e);
  for (; ne(t) && !Me(t); ) {
    if (Xt(t))
      return t;
    if (ut(t))
      return null;
    t = me(t);
  }
  return null;
}
function _t() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Me(e) {
  return ["html", "body", "#document"].includes(Re(e));
}
function te(e) {
  return X(e).getComputedStyle(e);
}
function Ct(e) {
  return ee(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function me(e) {
  if (Re(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    To(e) && e.host || // Fallback.
    re(e)
  );
  return To(t) ? t.host : t;
}
function mn(e) {
  const t = me(e);
  return Me(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ne(t) && Pe(t) ? t : mn(t);
}
function je(e, t, o) {
  var n;
  t === void 0 && (t = []), o === void 0 && (o = !0);
  const r = mn(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), A = X(r);
  if (i) {
    const a = Jt(A);
    return t.concat(A, A.visualViewport || [], Pe(r) ? r : [], a && o ? je(a) : []);
  }
  return t.concat(r, je(r, [], o));
}
function Jt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function hn(e) {
  const t = te(e);
  let o = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const r = ne(e), i = r ? e.offsetWidth : o, A = r ? e.offsetHeight : n, a = ot(o) !== i || ot(n) !== A;
  return a && (o = i, n = A), {
    width: o,
    height: n,
    $: a
  };
}
function $t(e) {
  return ee(e) ? e : e.contextElement;
}
function Ge(e) {
  const t = $t(e);
  if (!ne(t))
    return oe(1);
  const o = t.getBoundingClientRect(), {
    width: n,
    height: r,
    $: i
  } = hn(t);
  let A = (i ? ot(o.width) : o.width) / n, a = (i ? ot(o.height) : o.height) / r;
  return (!A || !Number.isFinite(A)) && (A = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: A,
    y: a
  };
}
const YA = /* @__PURE__ */ oe(0);
function In(e) {
  const t = X(e);
  return !_t() || !t.visualViewport ? YA : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function qA(e, t, o) {
  return t === void 0 && (t = !1), !o || t && o !== X(e) ? !1 : t;
}
function Qe(e, t, o, n) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  const r = e.getBoundingClientRect(), i = $t(e);
  let A = oe(1);
  t && (n ? ee(n) && (A = Ge(n)) : A = Ge(e));
  const a = qA(i, o, n) ? In(i) : oe(0);
  let c = (r.left + a.x) / A.x, s = (r.top + a.y) / A.y, u = r.width / A.x, C = r.height / A.y;
  if (i) {
    const h = X(i), m = n && ee(n) ? X(n) : n;
    let p = h, g = Jt(p);
    for (; g && n && m !== p; ) {
      const I = Ge(g), f = g.getBoundingClientRect(), B = te(g), w = f.left + (g.clientLeft + parseFloat(B.paddingLeft)) * I.x, E = f.top + (g.clientTop + parseFloat(B.paddingTop)) * I.y;
      c *= I.x, s *= I.y, u *= I.x, C *= I.y, c += w, s += E, p = X(g), g = Jt(p);
    }
  }
  return rt({
    width: u,
    height: C,
    x: c,
    y: s
  });
}
function eo(e, t) {
  const o = Ct(e).scrollLeft;
  return t ? t.left + o : Qe(re(e)).left + o;
}
function pn(e, t, o) {
  o === void 0 && (o = !1);
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - (o ? 0 : (
    // RTL <body> scrollbar.
    eo(e, n)
  )), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function DA(e) {
  let {
    elements: t,
    rect: o,
    offsetParent: n,
    strategy: r
  } = e;
  const i = r === "fixed", A = re(n), a = t ? ut(t.floating) : !1;
  if (n === A || a && i)
    return o;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = oe(1);
  const u = oe(0), C = ne(n);
  if ((C || !C && !i) && ((Re(n) !== "body" || Pe(A)) && (c = Ct(n)), ne(n))) {
    const m = Qe(n);
    s = Ge(n), u.x = m.x + n.clientLeft, u.y = m.y + n.clientTop;
  }
  const h = A && !C && !i ? pn(A, c, !0) : oe(0);
  return {
    width: o.width * s.x,
    height: o.height * s.y,
    x: o.x * s.x - c.scrollLeft * s.x + u.x + h.x,
    y: o.y * s.y - c.scrollTop * s.y + u.y + h.y
  };
}
function vA(e) {
  return Array.from(e.getClientRects());
}
function SA(e) {
  const t = re(e), o = Ct(e), n = e.ownerDocument.body, r = z(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = z(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let A = -o.scrollLeft + eo(e);
  const a = -o.scrollTop;
  return te(n).direction === "rtl" && (A += z(t.clientWidth, n.clientWidth) - r), {
    width: r,
    height: i,
    x: A,
    y: a
  };
}
function FA(e, t) {
  const o = X(e), n = re(e), r = o.visualViewport;
  let i = n.clientWidth, A = n.clientHeight, a = 0, c = 0;
  if (r) {
    i = r.width, A = r.height;
    const s = _t();
    (!s || s && t === "fixed") && (a = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: i,
    height: A,
    x: a,
    y: c
  };
}
function GA(e, t) {
  const o = Qe(e, !0, t === "fixed"), n = o.top + e.clientTop, r = o.left + e.clientLeft, i = ne(e) ? Ge(e) : oe(1), A = e.clientWidth * i.x, a = e.clientHeight * i.y, c = r * i.x, s = n * i.y;
  return {
    width: A,
    height: a,
    x: c,
    y: s
  };
}
function Vo(e, t, o) {
  let n;
  if (t === "viewport")
    n = FA(e, o);
  else if (t === "document")
    n = SA(re(e));
  else if (ee(t))
    n = GA(t, o);
  else {
    const r = In(e);
    n = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return rt(n);
}
function fn(e, t) {
  const o = me(e);
  return o === t || !ee(o) || Me(o) ? !1 : te(o).position === "fixed" || fn(o, t);
}
function OA(e, t) {
  const o = t.get(e);
  if (o)
    return o;
  let n = je(e, [], !1).filter((a) => ee(a) && Re(a) !== "body"), r = null;
  const i = te(e).position === "fixed";
  let A = i ? me(e) : e;
  for (; ee(A) && !Me(A); ) {
    const a = te(A), c = Xt(A);
    !c && a.position === "fixed" && (r = null), (i ? !c && !r : !c && a.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || Pe(A) && !c && fn(e, A)) ? n = n.filter((u) => u !== A) : r = a, A = me(A);
  }
  return t.set(e, n), n;
}
function MA(e) {
  let {
    element: t,
    boundary: o,
    rootBoundary: n,
    strategy: r
  } = e;
  const A = [...o === "clippingAncestors" ? ut(t) ? [] : OA(t, this._c) : [].concat(o), n], a = A[0], c = A.reduce((s, u) => {
    const C = Vo(t, u, r);
    return s.top = z(C.top, s.top), s.right = Ce(C.right, s.right), s.bottom = Ce(C.bottom, s.bottom), s.left = z(C.left, s.left), s;
  }, Vo(t, a, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function KA(e) {
  const {
    width: t,
    height: o
  } = hn(e);
  return {
    width: t,
    height: o
  };
}
function yA(e, t, o) {
  const n = ne(t), r = re(t), i = o === "fixed", A = Qe(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = oe(0);
  if (n || !n && !i)
    if ((Re(t) !== "body" || Pe(r)) && (a = Ct(t)), n) {
      const h = Qe(t, !0, i, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else r && (c.x = eo(r));
  const s = r && !n && !i ? pn(r, a) : oe(0), u = A.left + a.scrollLeft - c.x - s.x, C = A.top + a.scrollTop - c.y - s.y;
  return {
    x: u,
    y: C,
    width: A.width,
    height: A.height
  };
}
function vt(e) {
  return te(e).position === "static";
}
function zo(e, t) {
  if (!ne(e) || te(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let o = e.offsetParent;
  return re(e) === o && (o = o.ownerDocument.body), o;
}
function Bn(e, t) {
  const o = X(e);
  if (ut(e))
    return o;
  if (!ne(e)) {
    let r = me(e);
    for (; r && !Me(r); ) {
      if (ee(r) && !vt(r))
        return r;
      r = me(r);
    }
    return o;
  }
  let n = zo(e, t);
  for (; n && EA(n) && vt(n); )
    n = zo(n, t);
  return n && Me(n) && vt(n) && !Xt(n) ? o : n || QA(e) || o;
}
const RA = async function(e) {
  const t = this.getOffsetParent || Bn, o = this.getDimensions, n = await o(e.floating);
  return {
    reference: yA(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function kA(e) {
  return te(e).direction === "rtl";
}
const JA = {
  convertOffsetParentRelativeRectToViewportRelativeRect: DA,
  getDocumentElement: re,
  getClippingRect: MA,
  getOffsetParent: Bn,
  getElementRects: RA,
  getClientRects: vA,
  getDimensions: KA,
  getScale: Ge,
  isElement: ee,
  isRTL: kA
};
function bA(e, t) {
  let o = null, n;
  const r = re(e);
  function i() {
    var a;
    clearTimeout(n), (a = o) == null || a.disconnect(), o = null;
  }
  function A(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), i();
    const {
      left: s,
      top: u,
      width: C,
      height: h
    } = e.getBoundingClientRect();
    if (a || t(), !C || !h)
      return;
    const m = Ne(u), p = Ne(r.clientWidth - (s + C)), g = Ne(r.clientHeight - (u + h)), I = Ne(s), B = {
      rootMargin: -m + "px " + -p + "px " + -g + "px " + -I + "px",
      threshold: z(0, Ce(1, c)) || 1
    };
    let w = !0;
    function E(Q) {
      const D = Q[0].intersectionRatio;
      if (D !== c) {
        if (!w)
          return A();
        D ? A(!1, D) : n = setTimeout(() => {
          A(!1, 1e-7);
        }, 1e3);
      }
      w = !1;
    }
    try {
      o = new IntersectionObserver(E, {
        ...B,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(E, B);
    }
    o.observe(e);
  }
  return A(!0), i;
}
function UA(e, t, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: A = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, s = $t(e), u = r || i ? [...s ? je(s) : [], ...je(t)] : [];
  u.forEach((f) => {
    r && f.addEventListener("scroll", o, {
      passive: !0
    }), i && f.addEventListener("resize", o);
  });
  const C = s && a ? bA(s, o) : null;
  let h = -1, m = null;
  A && (m = new ResizeObserver((f) => {
    let [B] = f;
    B && B.target === s && m && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = m) == null || w.observe(t);
    })), o();
  }), s && !c && m.observe(s), m.observe(t));
  let p, g = c ? Qe(e) : null;
  c && I();
  function I() {
    const f = Qe(e);
    g && (f.x !== g.x || f.y !== g.y || f.width !== g.width || f.height !== g.height) && o(), g = f, p = requestAnimationFrame(I);
  }
  return o(), () => {
    var f;
    u.forEach((B) => {
      r && B.removeEventListener("scroll", o), i && B.removeEventListener("resize", o);
    }), C?.(), (f = m) == null || f.disconnect(), m = null, c && cancelAnimationFrame(p);
  };
}
const xA = pA, ZA = fA, WA = mA, jA = wA, HA = hA, Xo = dA, PA = BA, LA = (e, t, o) => {
  const n = /* @__PURE__ */ new Map(), r = {
    platform: JA,
    ...o
  }, i = {
    ...r.platform,
    _c: n
  };
  return CA(e, t, {
    ...r,
    platform: i
  });
};
var $e = typeof document < "u" ? Or : rn;
function it(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let o, n, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (o = e.length, o !== t.length) return !1;
      for (n = o; n-- !== 0; )
        if (!it(e[n], t[n]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), o = r.length, o !== Object.keys(t).length)
      return !1;
    for (n = o; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[n]))
        return !1;
    for (n = o; n-- !== 0; ) {
      const i = r[n];
      if (!(i === "_owner" && e.$$typeof) && !it(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function wn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _o(e, t) {
  const o = wn(e);
  return Math.round(t * o) / o;
}
function St(e) {
  const t = l.useRef(e);
  return $e(() => {
    t.current = e;
  }), t;
}
function NA(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: o = "absolute",
    middleware: n = [],
    platform: r,
    elements: {
      reference: i,
      floating: A
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: s
  } = e, [u, C] = l.useState({
    x: 0,
    y: 0,
    strategy: o,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = l.useState(n);
  it(h, n) || m(n);
  const [p, g] = l.useState(null), [I, f] = l.useState(null), B = l.useCallback((v) => {
    v !== D.current && (D.current = v, g(v));
  }, []), w = l.useCallback((v) => {
    v !== Y.current && (Y.current = v, f(v));
  }, []), E = i || p, Q = A || I, D = l.useRef(null), Y = l.useRef(null), S = l.useRef(u), O = c != null, M = St(c), R = St(r), k = St(s), y = l.useCallback(() => {
    if (!D.current || !Y.current)
      return;
    const v = {
      placement: t,
      strategy: o,
      middleware: h
    };
    R.current && (v.platform = R.current), LA(D.current, Y.current, v).then((J) => {
      const V = {
        ...J,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      G.current && !it(S.current, V) && (S.current = V, lt.flushSync(() => {
        C(V);
      }));
    });
  }, [h, t, o, R, k]);
  $e(() => {
    s === !1 && S.current.isPositioned && (S.current.isPositioned = !1, C((v) => ({
      ...v,
      isPositioned: !1
    })));
  }, [s]);
  const G = l.useRef(!1);
  $e(() => (G.current = !0, () => {
    G.current = !1;
  }), []), $e(() => {
    if (E && (D.current = E), Q && (Y.current = Q), E && Q) {
      if (M.current)
        return M.current(E, Q, y);
      y();
    }
  }, [E, Q, y, M, O]);
  const j = l.useMemo(() => ({
    reference: D,
    floating: Y,
    setReference: B,
    setFloating: w
  }), [B, w]), F = l.useMemo(() => ({
    reference: E,
    floating: Q
  }), [E, Q]), K = l.useMemo(() => {
    const v = {
      position: o,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return v;
    const J = _o(F.floating, u.x), V = _o(F.floating, u.y);
    return a ? {
      ...v,
      transform: "translate(" + J + "px, " + V + "px)",
      ...wn(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: o,
      left: J,
      top: V
    };
  }, [o, a, F.floating, u.x, u.y]);
  return l.useMemo(() => ({
    ...u,
    update: y,
    refs: j,
    elements: F,
    floatingStyles: K
  }), [u, y, j, F, K]);
}
const TA = (e) => {
  function t(o) {
    return {}.hasOwnProperty.call(o, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(o) {
      const {
        element: n,
        padding: r
      } = typeof e == "function" ? e(o) : e;
      return n && t(n) ? n.current != null ? Xo({
        element: n.current,
        padding: r
      }).fn(o) : {} : n ? Xo({
        element: n,
        padding: r
      }).fn(o) : {};
    }
  };
}, VA = (e, t) => ({
  ...xA(e),
  options: [e, t]
}), zA = (e, t) => ({
  ...ZA(e),
  options: [e, t]
}), XA = (e, t) => ({
  ...PA(e),
  options: [e, t]
}), _A = (e, t) => ({
  ...WA(e),
  options: [e, t]
}), $A = (e, t) => ({
  ...jA(e),
  options: [e, t]
}), ea = (e, t) => ({
  ...HA(e),
  options: [e, t]
}), ta = (e, t) => ({
  ...TA(e),
  options: [e, t]
});
var oa = "Arrow", En = l.forwardRef((e, t) => {
  const { children: o, width: n = 10, height: r = 5, ...i } = e;
  return /* @__PURE__ */ d(
    W.svg,
    {
      ...i,
      ref: t,
      width: n,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? o : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
En.displayName = oa;
var na = En;
function ra(e) {
  const [t, o] = l.useState(void 0);
  return N(() => {
    if (e) {
      o({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const i = r[0];
        let A, a;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, s = Array.isArray(c) ? c[0] : c;
          A = s.inlineSize, a = s.blockSize;
        } else
          A = e.offsetWidth, a = e.offsetHeight;
        o({ width: A, height: a });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      o(void 0);
  }, [e]), t;
}
var to = "Popper", [Qn, dt] = ct(to), [ia, Yn] = Qn(to), qn = (e) => {
  const { __scopePopper: t, children: o } = e, [n, r] = l.useState(null);
  return /* @__PURE__ */ d(ia, { scope: t, anchor: n, onAnchorChange: r, children: o });
};
qn.displayName = to;
var Dn = "PopperAnchor", vn = l.forwardRef(
  (e, t) => {
    const { __scopePopper: o, virtualRef: n, ...r } = e, i = Yn(Dn, o), A = l.useRef(null), a = L(t, A);
    return l.useEffect(() => {
      i.onAnchorChange(n?.current || A.current);
    }), n ? null : /* @__PURE__ */ d(W.div, { ...r, ref: a });
  }
);
vn.displayName = Dn;
var oo = "PopperContent", [Aa, aa] = Qn(oo), Sn = l.forwardRef(
  (e, t) => {
    const {
      __scopePopper: o,
      side: n = "bottom",
      sideOffset: r = 0,
      align: i = "center",
      alignOffset: A = 0,
      arrowPadding: a = 0,
      avoidCollisions: c = !0,
      collisionBoundary: s = [],
      collisionPadding: u = 0,
      sticky: C = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: p,
      ...g
    } = e, I = Yn(oo, o), [f, B] = l.useState(null), w = L(t, (q) => B(q)), [E, Q] = l.useState(null), D = ra(E), Y = D?.width ?? 0, S = D?.height ?? 0, O = n + (i !== "center" ? "-" + i : ""), M = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, R = Array.isArray(s) ? s : [s], k = R.length > 0, y = {
      padding: M,
      boundary: R.filter(ca),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: k
    }, { refs: G, floatingStyles: j, placement: F, isPositioned: K, middlewareData: v } = NA({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: O,
      whileElementsMounted: (...q) => UA(...q, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: I.anchor
      },
      middleware: [
        VA({ mainAxis: r + S, alignmentAxis: A }),
        c && zA({
          mainAxis: !0,
          crossAxis: !1,
          limiter: C === "partial" ? XA() : void 0,
          ...y
        }),
        c && _A({ ...y }),
        $A({
          ...y,
          apply: ({ elements: q, rects: H, availableWidth: T, availableHeight: b }) => {
            const { width: x, height: P } = H.reference, _ = q.floating.style;
            _.setProperty("--radix-popper-available-width", `${T}px`), _.setProperty("--radix-popper-available-height", `${b}px`), _.setProperty("--radix-popper-anchor-width", `${x}px`), _.setProperty("--radix-popper-anchor-height", `${P}px`);
          }
        }),
        E && ta({ element: E, padding: a }),
        sa({ arrowWidth: Y, arrowHeight: S }),
        h && ea({ strategy: "referenceHidden", ...y })
      ]
    }), [J, V] = On(F), fe = Ee(p);
    N(() => {
      K && fe?.();
    }, [K, fe]);
    const Je = v.arrow?.x, be = v.arrow?.y, le = v.arrow?.centerOffset !== 0, [De, Be] = l.useState();
    return N(() => {
      f && Be(window.getComputedStyle(f).zIndex);
    }, [f]), /* @__PURE__ */ d(
      "div",
      {
        ref: G.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...j,
          transform: K ? j.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: De,
          "--radix-popper-transform-origin": [
            v.transformOrigin?.x,
            v.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...v.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          Aa,
          {
            scope: o,
            placedSide: J,
            onArrowChange: Q,
            arrowX: Je,
            arrowY: be,
            shouldHideArrow: le,
            children: /* @__PURE__ */ d(
              W.div,
              {
                "data-side": J,
                "data-align": V,
                ...g,
                ref: w,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Sn.displayName = oo;
var Fn = "PopperArrow", la = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Gn = l.forwardRef(function(t, o) {
  const { __scopePopper: n, ...r } = t, i = aa(Fn, n), A = la[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [A]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          na,
          {
            ...r,
            ref: o,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Gn.displayName = Fn;
function ca(e) {
  return e !== null;
}
var sa = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: o, rects: n, middlewareData: r } = t, A = r.arrow?.centerOffset !== 0, a = A ? 0 : e.arrowWidth, c = A ? 0 : e.arrowHeight, [s, u] = On(o), C = { start: "0%", center: "50%", end: "100%" }[u], h = (r.arrow?.x ?? 0) + a / 2, m = (r.arrow?.y ?? 0) + c / 2;
    let p = "", g = "";
    return s === "bottom" ? (p = A ? C : `${h}px`, g = `${-c}px`) : s === "top" ? (p = A ? C : `${h}px`, g = `${n.floating.height + c}px`) : s === "right" ? (p = `${-c}px`, g = A ? C : `${m}px`) : s === "left" && (p = `${n.floating.width + c}px`, g = A ? C : `${m}px`), { data: { x: p, y: g } };
  }
});
function On(e) {
  const [t, o = "center"] = e.split("-");
  return [t, o];
}
var Mn = qn, no = vn, Kn = Sn, yn = Gn, ga = "Portal", ro = l.forwardRef((e, t) => {
  const { container: o, ...n } = e, [r, i] = l.useState(!1);
  N(() => i(!0), []);
  const A = o || r && globalThis?.document?.body;
  return A ? yr.createPortal(/* @__PURE__ */ d(W.div, { ...n, ref: t }), A) : null;
});
ro.displayName = ga;
var ua = l[" useInsertionEffect ".trim().toString()] || N;
function bt({
  prop: e,
  defaultProp: t,
  onChange: o = () => {
  },
  caller: n
}) {
  const [r, i, A] = Ca({
    defaultProp: t,
    onChange: o
  }), a = e !== void 0, c = a ? e : r;
  {
    const u = l.useRef(e !== void 0);
    l.useEffect(() => {
      const C = u.current;
      C !== a && console.warn(
        `${n} is changing from ${C ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, n]);
  }
  const s = l.useCallback(
    (u) => {
      if (a) {
        const C = da(u) ? u(e) : u;
        C !== e && A.current?.(C);
      } else
        i(u);
    },
    [a, e, i, A]
  );
  return [c, s];
}
function Ca({
  defaultProp: e,
  onChange: t
}) {
  const [o, n] = l.useState(e), r = l.useRef(o), i = l.useRef(t);
  return ua(() => {
    i.current = t;
  }, [t]), l.useEffect(() => {
    r.current !== o && (i.current?.(o), r.current = o);
  }, [o, r]), [o, n, i];
}
function da(e) {
  return typeof e == "function";
}
function ma(e) {
  const t = l.useRef({ value: e, previous: e });
  return l.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Rn = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), ha = "VisuallyHidden", Ia = l.forwardRef(
  (e, t) => /* @__PURE__ */ d(
    W.span,
    {
      ...e,
      ref: t,
      style: { ...Rn, ...e.style }
    }
  )
);
Ia.displayName = ha;
var pa = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ve = /* @__PURE__ */ new WeakMap(), Te = /* @__PURE__ */ new WeakMap(), Ve = {}, Ft = 0, kn = function(e) {
  return e && (e.host || kn(e.parentNode));
}, fa = function(e, t) {
  return t.map(function(o) {
    if (e.contains(o))
      return o;
    var n = kn(o);
    return n && e.contains(n) ? n : (console.error("aria-hidden", o, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(o) {
    return !!o;
  });
}, Ba = function(e, t, o, n) {
  var r = fa(t, Array.isArray(e) ? e : [e]);
  Ve[o] || (Ve[o] = /* @__PURE__ */ new WeakMap());
  var i = Ve[o], A = [], a = /* @__PURE__ */ new Set(), c = new Set(r), s = function(C) {
    !C || a.has(C) || (a.add(C), s(C.parentNode));
  };
  r.forEach(s);
  var u = function(C) {
    !C || c.has(C) || Array.prototype.forEach.call(C.children, function(h) {
      if (a.has(h))
        u(h);
      else
        try {
          var m = h.getAttribute(n), p = m !== null && m !== "false", g = (ve.get(h) || 0) + 1, I = (i.get(h) || 0) + 1;
          ve.set(h, g), i.set(h, I), A.push(h), g === 1 && p && Te.set(h, !0), I === 1 && h.setAttribute(o, "true"), p || h.setAttribute(n, "true");
        } catch (f) {
          console.error("aria-hidden: cannot operate on ", h, f);
        }
    });
  };
  return u(t), a.clear(), Ft++, function() {
    A.forEach(function(C) {
      var h = ve.get(C) - 1, m = i.get(C) - 1;
      ve.set(C, h), i.set(C, m), h || (Te.has(C) || C.removeAttribute(n), Te.delete(C)), m || C.removeAttribute(o);
    }), Ft--, Ft || (ve = /* @__PURE__ */ new WeakMap(), ve = /* @__PURE__ */ new WeakMap(), Te = /* @__PURE__ */ new WeakMap(), Ve = {});
  };
}, Jn = function(e, t, o) {
  o === void 0 && (o = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), r = pa(e);
  return r ? (n.push.apply(n, Array.from(r.querySelectorAll("[aria-live]"))), Ba(n, r, o, "aria-hidden")) : function() {
    return null;
  };
}, ge = function() {
  return ge = Object.assign || function(t) {
    for (var o, n = 1, r = arguments.length; n < r; n++) {
      o = arguments[n];
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
    }
    return t;
  }, ge.apply(this, arguments);
};
function wa(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (o[n[r]] = e[n[r]]);
  return o;
}
function Ea(e, t, o) {
  if (o || arguments.length === 2) for (var n = 0, r = t.length, i; n < r; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var et = "right-scroll-bar-position", tt = "width-before-scroll-bar", Qa = "with-scroll-bars-hidden", Ya = "--removed-body-scroll-bar-size";
function Gt(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function qa(e, t) {
  var o = Mr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return o.value;
        },
        set current(n) {
          var r = o.value;
          r !== n && (o.value = n, o.callback(n, r));
        }
      }
    };
  })[0];
  return o.callback = t, o.facade;
}
var Da = typeof window < "u" ? l.useLayoutEffect : l.useEffect, $o = /* @__PURE__ */ new WeakMap();
function va(e, t) {
  var o = qa(null, function(n) {
    return e.forEach(function(r) {
      return Gt(r, n);
    });
  });
  return Da(function() {
    var n = $o.get(o);
    if (n) {
      var r = new Set(n), i = new Set(e), A = o.current;
      r.forEach(function(a) {
        i.has(a) || Gt(a, null);
      }), i.forEach(function(a) {
        r.has(a) || Gt(a, A);
      });
    }
    $o.set(o, e);
  }, [e]), o;
}
var At = function() {
  return At = Object.assign || function(t) {
    for (var o, n = 1, r = arguments.length; n < r; n++) {
      o = arguments[n];
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
    }
    return t;
  }, At.apply(this, arguments);
};
function Sa(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (o[n[r]] = e[n[r]]);
  return o;
}
function Fa(e) {
  return e;
}
function Ga(e, t) {
  t === void 0 && (t = Fa);
  var o = [], n = !1, r = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return o.length ? o[o.length - 1] : e;
    },
    useMedium: function(i) {
      var A = t(i, n);
      return o.push(A), function() {
        o = o.filter(function(a) {
          return a !== A;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; o.length; ) {
        var A = o;
        o = [], A.forEach(i);
      }
      o = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return o;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var A = [];
      if (o.length) {
        var a = o;
        o = [], a.forEach(i), A = o;
      }
      var c = function() {
        var u = A;
        A = [], u.forEach(i);
      }, s = function() {
        return Promise.resolve().then(c);
      };
      s(), o = {
        push: function(u) {
          A.push(u), s();
        },
        filter: function(u) {
          return A = A.filter(u), o;
        }
      };
    }
  };
  return r;
}
function Oa(e) {
  e === void 0 && (e = {});
  var t = Ga(null);
  return t.options = At({ async: !0, ssr: !1 }, e), t;
}
var bn = function(e) {
  var t = e.sideCar, o = Sa(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return l.createElement(n, At({}, o));
};
bn.isSideCarExport = !0;
function Ma(e, t) {
  return e.useMedium(t), bn;
}
var Un = Oa(), Ot = function() {
}, mt = l.forwardRef(function(e, t) {
  var o = l.useRef(null), n = l.useState({
    onScrollCapture: Ot,
    onWheelCapture: Ot,
    onTouchMoveCapture: Ot
  }), r = n[0], i = n[1], A = e.forwardProps, a = e.children, c = e.className, s = e.removeScrollBar, u = e.enabled, C = e.shards, h = e.sideCar, m = e.noIsolation, p = e.inert, g = e.allowPinchZoom, I = e.as, f = I === void 0 ? "div" : I, B = e.gapMode, w = wa(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = h, Q = va([o, t]), D = ge(ge({}, w), r);
  return l.createElement(
    l.Fragment,
    null,
    u && l.createElement(E, { sideCar: Un, removeScrollBar: s, shards: C, noIsolation: m, inert: p, setCallbacks: i, allowPinchZoom: !!g, lockRef: o, gapMode: B }),
    A ? l.cloneElement(l.Children.only(a), ge(ge({}, D), { ref: Q })) : l.createElement(f, ge({}, D, { className: c, ref: Q }), a)
  );
});
mt.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
mt.classNames = {
  fullWidth: tt,
  zeroRight: et
};
var Ka = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ya() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ka();
  return t && e.setAttribute("nonce", t), e;
}
function Ra(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ka(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Ja = function() {
  var e = 0, t = null;
  return {
    add: function(o) {
      e == 0 && (t = ya()) && (Ra(t, o), ka(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, ba = function() {
  var e = Ja();
  return function(t, o) {
    l.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && o]);
  };
}, xn = function() {
  var e = ba(), t = function(o) {
    var n = o.styles, r = o.dynamic;
    return e(n, r), null;
  };
  return t;
}, Ua = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Mt = function(e) {
  return parseInt(e || "", 10) || 0;
}, xa = function(e) {
  var t = window.getComputedStyle(document.body), o = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Mt(o), Mt(n), Mt(r)];
}, Za = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Ua;
  var t = xa(e), o = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - o + t[2] - t[0])
  };
}, Wa = xn(), Oe = "data-scroll-locked", ja = function(e, t, o, n) {
  var r = e.left, i = e.top, A = e.right, a = e.gap;
  return o === void 0 && (o = "margin"), `
  .`.concat(Qa, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(a, "px ").concat(n, `;
  }
  body[`).concat(Oe, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    o === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(A, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(n, `;
    `),
    o === "padding" && "padding-right: ".concat(a, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(et, ` {
    right: `).concat(a, "px ").concat(n, `;
  }
  
  .`).concat(tt, ` {
    margin-right: `).concat(a, "px ").concat(n, `;
  }
  
  .`).concat(et, " .").concat(et, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(tt, " .").concat(tt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(Oe, `] {
    `).concat(Ya, ": ").concat(a, `px;
  }
`);
}, en = function() {
  var e = parseInt(document.body.getAttribute(Oe) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ha = function() {
  l.useEffect(function() {
    return document.body.setAttribute(Oe, (en() + 1).toString()), function() {
      var e = en() - 1;
      e <= 0 ? document.body.removeAttribute(Oe) : document.body.setAttribute(Oe, e.toString());
    };
  }, []);
}, Pa = function(e) {
  var t = e.noRelative, o = e.noImportant, n = e.gapMode, r = n === void 0 ? "margin" : n;
  Ha();
  var i = l.useMemo(function() {
    return Za(r);
  }, [r]);
  return l.createElement(Wa, { styles: ja(i, !t, r, o ? "" : "!important") });
}, Ut = !1;
if (typeof window < "u")
  try {
    var ze = Object.defineProperty({}, "passive", {
      get: function() {
        return Ut = !0, !0;
      }
    });
    window.addEventListener("test", ze, ze), window.removeEventListener("test", ze, ze);
  } catch {
    Ut = !1;
  }
var Se = Ut ? { passive: !1 } : !1, La = function(e) {
  return e.tagName === "TEXTAREA";
}, Zn = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var o = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    o[t] !== "hidden" && // contains scroll inside self
    !(o.overflowY === o.overflowX && !La(e) && o[t] === "visible")
  );
}, Na = function(e) {
  return Zn(e, "overflowY");
}, Ta = function(e) {
  return Zn(e, "overflowX");
}, tn = function(e, t) {
  var o = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Wn(e, n);
    if (r) {
      var i = jn(e, n), A = i[1], a = i[2];
      if (A > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== o.body);
  return !1;
}, Va = function(e) {
  var t = e.scrollTop, o = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    o,
    n
  ];
}, za = function(e) {
  var t = e.scrollLeft, o = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    o,
    n
  ];
}, Wn = function(e, t) {
  return e === "v" ? Na(t) : Ta(t);
}, jn = function(e, t) {
  return e === "v" ? Va(t) : za(t);
}, Xa = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, _a = function(e, t, o, n, r) {
  var i = Xa(e, window.getComputedStyle(t).direction), A = i * n, a = o.target, c = t.contains(a), s = !1, u = A > 0, C = 0, h = 0;
  do {
    var m = jn(e, a), p = m[0], g = m[1], I = m[2], f = g - I - i * p;
    (p || f) && Wn(e, a) && (C += f, h += p), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (u && Math.abs(C) < 1 || !u && Math.abs(h) < 1) && (s = !0), s;
}, Xe = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, on = function(e) {
  return [e.deltaX, e.deltaY];
}, nn = function(e) {
  return e && "current" in e ? e.current : e;
}, $a = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, el = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, tl = 0, Fe = [];
function ol(e) {
  var t = l.useRef([]), o = l.useRef([0, 0]), n = l.useRef(), r = l.useState(tl++)[0], i = l.useState(xn)[0], A = l.useRef(e);
  l.useEffect(function() {
    A.current = e;
  }, [e]), l.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var g = Ea([e.lockRef.current], (e.shards || []).map(nn), !0).filter(Boolean);
      return g.forEach(function(I) {
        return I.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), g.forEach(function(I) {
          return I.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = l.useCallback(function(g, I) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !A.current.allowPinchZoom;
    var f = Xe(g), B = o.current, w = "deltaX" in g ? g.deltaX : B[0] - f[0], E = "deltaY" in g ? g.deltaY : B[1] - f[1], Q, D = g.target, Y = Math.abs(w) > Math.abs(E) ? "h" : "v";
    if ("touches" in g && Y === "h" && D.type === "range")
      return !1;
    var S = tn(Y, D);
    if (!S)
      return !0;
    if (S ? Q = Y : (Q = Y === "v" ? "h" : "v", S = tn(Y, D)), !S)
      return !1;
    if (!n.current && "changedTouches" in g && (w || E) && (n.current = Q), !Q)
      return !0;
    var O = n.current || Q;
    return _a(O, I, g, O === "h" ? w : E);
  }, []), c = l.useCallback(function(g) {
    var I = g;
    if (!(!Fe.length || Fe[Fe.length - 1] !== i)) {
      var f = "deltaY" in I ? on(I) : Xe(I), B = t.current.filter(function(Q) {
        return Q.name === I.type && (Q.target === I.target || I.target === Q.shadowParent) && $a(Q.delta, f);
      })[0];
      if (B && B.should) {
        I.cancelable && I.preventDefault();
        return;
      }
      if (!B) {
        var w = (A.current.shards || []).map(nn).filter(Boolean).filter(function(Q) {
          return Q.contains(I.target);
        }), E = w.length > 0 ? a(I, w[0]) : !A.current.noIsolation;
        E && I.cancelable && I.preventDefault();
      }
    }
  }, []), s = l.useCallback(function(g, I, f, B) {
    var w = { name: g, delta: I, target: f, should: B, shadowParent: nl(f) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== w;
      });
    }, 1);
  }, []), u = l.useCallback(function(g) {
    o.current = Xe(g), n.current = void 0;
  }, []), C = l.useCallback(function(g) {
    s(g.type, on(g), g.target, a(g, e.lockRef.current));
  }, []), h = l.useCallback(function(g) {
    s(g.type, Xe(g), g.target, a(g, e.lockRef.current));
  }, []);
  l.useEffect(function() {
    return Fe.push(i), e.setCallbacks({
      onScrollCapture: C,
      onWheelCapture: C,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, Se), document.addEventListener("touchmove", c, Se), document.addEventListener("touchstart", u, Se), function() {
      Fe = Fe.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", c, Se), document.removeEventListener("touchmove", c, Se), document.removeEventListener("touchstart", u, Se);
    };
  }, []);
  var m = e.removeScrollBar, p = e.inert;
  return l.createElement(
    l.Fragment,
    null,
    p ? l.createElement(i, { styles: el(r) }) : null,
    m ? l.createElement(Pa, { gapMode: e.gapMode }) : null
  );
}
function nl(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const rl = Ma(Un, ol);
var io = l.forwardRef(function(e, t) {
  return l.createElement(mt, ge({}, e, { ref: t, sideCar: rl }));
});
io.classNames = mt.classNames;
var il = [" ", "Enter", "ArrowUp", "ArrowDown"], Al = [" ", "Enter"], Ye = "Select", [ht, It, al] = Ui(Ye), [ke, ll] = ct(Ye, [
  al,
  dt
]), pt = dt(), [cl, he] = ke(Ye), [sl, gl] = ke(Ye), Ao = (e) => {
  const {
    __scopeSelect: t,
    children: o,
    open: n,
    defaultOpen: r,
    onOpenChange: i,
    value: A,
    defaultValue: a,
    onValueChange: c,
    dir: s,
    name: u,
    autoComplete: C,
    disabled: h,
    required: m,
    form: p
  } = e, g = pt(t), [I, f] = l.useState(null), [B, w] = l.useState(null), [E, Q] = l.useState(!1), D = Zi(s), [Y, S] = bt({
    prop: n,
    defaultProp: r ?? !1,
    onChange: i,
    caller: Ye
  }), [O, M] = bt({
    prop: A,
    defaultProp: a,
    onChange: c,
    caller: Ye
  }), R = l.useRef(null), k = I ? p || !!I.closest("form") : !0, [y, G] = l.useState(/* @__PURE__ */ new Set()), j = Array.from(y).map((F) => F.props.value).join(";");
  return /* @__PURE__ */ d(Mn, { ...g, children: /* @__PURE__ */ Z(
    cl,
    {
      required: m,
      scope: t,
      trigger: I,
      onTriggerChange: f,
      valueNode: B,
      onValueNodeChange: w,
      valueNodeHasChildren: E,
      onValueNodeHasChildrenChange: Q,
      contentId: st(),
      value: O,
      onValueChange: M,
      open: Y,
      onOpenChange: S,
      dir: D,
      triggerPointerDownPosRef: R,
      disabled: h,
      children: [
        /* @__PURE__ */ d(ht.Provider, { scope: t, children: /* @__PURE__ */ d(
          sl,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: l.useCallback((F) => {
              G((K) => new Set(K).add(F));
            }, []),
            onNativeOptionRemove: l.useCallback((F) => {
              G((K) => {
                const v = new Set(K);
                return v.delete(F), v;
              });
            }, []),
            children: o
          }
        ) }),
        k ? /* @__PURE__ */ Z(
          er,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: u,
            autoComplete: C,
            value: O,
            onChange: (F) => M(F.target.value),
            disabled: h,
            form: p,
            children: [
              O === void 0 ? /* @__PURE__ */ d("option", { value: "" }) : null,
              Array.from(y)
            ]
          },
          j
        ) : null
      ]
    }
  ) });
};
Ao.displayName = Ye;
var Hn = "SelectTrigger", ao = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, disabled: n = !1, ...r } = e, i = pt(o), A = he(Hn, o), a = A.disabled || n, c = L(t, A.onTriggerChange), s = It(o), u = l.useRef("touch"), [C, h, m] = or((g) => {
      const I = s().filter((w) => !w.disabled), f = I.find((w) => w.value === A.value), B = nr(I, g, f);
      B !== void 0 && A.onValueChange(B.value);
    }), p = (g) => {
      a || (A.onOpenChange(!0), m()), g && (A.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ d(no, { asChild: !0, ...i, children: /* @__PURE__ */ d(
      W.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": A.contentId,
        "aria-expanded": A.open,
        "aria-required": A.required,
        "aria-autocomplete": "none",
        dir: A.dir,
        "data-state": A.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": tr(A.value) ? "" : void 0,
        ...r,
        ref: c,
        onClick: U(r.onClick, (g) => {
          g.currentTarget.focus(), u.current !== "mouse" && p(g);
        }),
        onPointerDown: U(r.onPointerDown, (g) => {
          u.current = g.pointerType;
          const I = g.target;
          I.hasPointerCapture(g.pointerId) && I.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (p(g), g.preventDefault());
        }),
        onKeyDown: U(r.onKeyDown, (g) => {
          const I = C.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && h(g.key), !(I && g.key === " ") && il.includes(g.key) && (p(), g.preventDefault());
        })
      }
    ) });
  }
);
ao.displayName = Hn;
var Pn = "SelectValue", lo = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, className: n, style: r, children: i, placeholder: A = "", ...a } = e, c = he(Pn, o), { onValueNodeHasChildrenChange: s } = c, u = i !== void 0, C = L(t, c.onValueNodeChange);
    return N(() => {
      s(u);
    }, [s, u]), /* @__PURE__ */ d(
      W.span,
      {
        ...a,
        ref: C,
        style: { pointerEvents: "none" },
        children: tr(c.value) ? /* @__PURE__ */ d(He, { children: A }) : i
      }
    );
  }
);
lo.displayName = Pn;
var ul = "SelectIcon", ft = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, children: n, ...r } = e;
    return /* @__PURE__ */ d(W.span, { "aria-hidden": !0, ...r, ref: t, children: n || "▼" });
  }
);
ft.displayName = ul;
var Cl = "SelectPortal", co = (e) => /* @__PURE__ */ d(ro, { asChild: !0, ...e });
co.displayName = Cl;
var qe = "SelectContent", so = l.forwardRef(
  (e, t) => {
    const o = he(qe, e.__scopeSelect), [n, r] = l.useState();
    if (N(() => {
      r(new DocumentFragment());
    }, []), !o.open) {
      const i = n;
      return i ? lt.createPortal(
        /* @__PURE__ */ d(Ln, { scope: e.__scopeSelect, children: /* @__PURE__ */ d(ht.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ d("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ d(Nn, { ...e, ref: t });
  }
);
so.displayName = qe;
var $ = 10, [Ln, Ie] = ke(qe), dl = "SelectContentImpl", ml = /* @__PURE__ */ Ze("SelectContent.RemoveScroll"), Nn = l.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: o,
      position: n = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: i,
      onPointerDownOutside: A,
      //
      // PopperContent props
      side: a,
      sideOffset: c,
      align: s,
      alignOffset: u,
      arrowPadding: C,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: p,
      hideWhenDetached: g,
      avoidCollisions: I,
      //
      ...f
    } = e, B = he(qe, o), [w, E] = l.useState(null), [Q, D] = l.useState(null), Y = L(t, (q) => E(q)), [S, O] = l.useState(null), [M, R] = l.useState(
      null
    ), k = It(o), [y, G] = l.useState(!1), j = l.useRef(!1);
    l.useEffect(() => {
      if (w) return Jn(w);
    }, [w]), gn();
    const F = l.useCallback(
      (q) => {
        const [H, ...T] = k().map((P) => P.ref.current), [b] = T.slice(-1), x = document.activeElement;
        for (const P of q)
          if (P === x || (P?.scrollIntoView({ block: "nearest" }), P === H && Q && (Q.scrollTop = 0), P === b && Q && (Q.scrollTop = Q.scrollHeight), P?.focus(), document.activeElement !== x)) return;
      },
      [k, Q]
    ), K = l.useCallback(
      () => F([S, w]),
      [F, S, w]
    );
    l.useEffect(() => {
      y && K();
    }, [y, K]);
    const { onOpenChange: v, triggerPointerDownPosRef: J } = B;
    l.useEffect(() => {
      if (w) {
        let q = { x: 0, y: 0 };
        const H = (b) => {
          q = {
            x: Math.abs(Math.round(b.pageX) - (J.current?.x ?? 0)),
            y: Math.abs(Math.round(b.pageY) - (J.current?.y ?? 0))
          };
        }, T = (b) => {
          q.x <= 10 && q.y <= 10 ? b.preventDefault() : w.contains(b.target) || v(!1), document.removeEventListener("pointermove", H), J.current = null;
        };
        return J.current !== null && (document.addEventListener("pointermove", H), document.addEventListener("pointerup", T, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", H), document.removeEventListener("pointerup", T, { capture: !0 });
        };
      }
    }, [w, v, J]), l.useEffect(() => {
      const q = () => v(!1);
      return window.addEventListener("blur", q), window.addEventListener("resize", q), () => {
        window.removeEventListener("blur", q), window.removeEventListener("resize", q);
      };
    }, [v]);
    const [V, fe] = or((q) => {
      const H = k().filter((x) => !x.disabled), T = H.find((x) => x.ref.current === document.activeElement), b = nr(H, q, T);
      b && setTimeout(() => b.ref.current.focus());
    }), Je = l.useCallback(
      (q, H, T) => {
        const b = !j.current && !T;
        (B.value !== void 0 && B.value === H || b) && (O(q), b && (j.current = !0));
      },
      [B.value]
    ), be = l.useCallback(() => w?.focus(), [w]), le = l.useCallback(
      (q, H, T) => {
        const b = !j.current && !T;
        (B.value !== void 0 && B.value === H || b) && R(q);
      },
      [B.value]
    ), De = n === "popper" ? xt : Tn, Be = De === xt ? {
      side: a,
      sideOffset: c,
      align: s,
      alignOffset: u,
      arrowPadding: C,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: p,
      hideWhenDetached: g,
      avoidCollisions: I
    } : {};
    return /* @__PURE__ */ d(
      Ln,
      {
        scope: o,
        content: w,
        viewport: Q,
        onViewportChange: D,
        itemRefCallback: Je,
        selectedItem: S,
        onItemLeave: be,
        itemTextRefCallback: le,
        focusSelectedItem: K,
        selectedItemText: M,
        position: n,
        isPositioned: y,
        searchRef: V,
        children: /* @__PURE__ */ d(io, { as: ml, allowPinchZoom: !0, children: /* @__PURE__ */ d(
          Nt,
          {
            asChild: !0,
            trapped: B.open,
            onMountAutoFocus: (q) => {
              q.preventDefault();
            },
            onUnmountAutoFocus: U(r, (q) => {
              B.trigger?.focus({ preventScroll: !0 }), q.preventDefault();
            }),
            children: /* @__PURE__ */ d(
              Lt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: A,
                onFocusOutside: (q) => q.preventDefault(),
                onDismiss: () => B.onOpenChange(!1),
                children: /* @__PURE__ */ d(
                  De,
                  {
                    role: "listbox",
                    id: B.contentId,
                    "data-state": B.open ? "open" : "closed",
                    dir: B.dir,
                    onContextMenu: (q) => q.preventDefault(),
                    ...f,
                    ...Be,
                    onPlaced: () => G(!0),
                    ref: Y,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...f.style
                    },
                    onKeyDown: U(f.onKeyDown, (q) => {
                      const H = q.ctrlKey || q.altKey || q.metaKey;
                      if (q.key === "Tab" && q.preventDefault(), !H && q.key.length === 1 && fe(q.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(q.key)) {
                        let b = k().filter((x) => !x.disabled).map((x) => x.ref.current);
                        if (["ArrowUp", "End"].includes(q.key) && (b = b.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(q.key)) {
                          const x = q.target, P = b.indexOf(x);
                          b = b.slice(P + 1);
                        }
                        setTimeout(() => F(b)), q.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Nn.displayName = dl;
var hl = "SelectItemAlignedPosition", Tn = l.forwardRef((e, t) => {
  const { __scopeSelect: o, onPlaced: n, ...r } = e, i = he(qe, o), A = Ie(qe, o), [a, c] = l.useState(null), [s, u] = l.useState(null), C = L(t, (Y) => u(Y)), h = It(o), m = l.useRef(!1), p = l.useRef(!0), { viewport: g, selectedItem: I, selectedItemText: f, focusSelectedItem: B } = A, w = l.useCallback(() => {
    if (i.trigger && i.valueNode && a && s && g && I && f) {
      const Y = i.trigger.getBoundingClientRect(), S = s.getBoundingClientRect(), O = i.valueNode.getBoundingClientRect(), M = f.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const x = M.left - S.left, P = O.left - x, _ = Y.left - P, we = Y.width + _, wt = Math.max(we, S.width), Et = window.innerWidth - $, Qt = Jo(P, [
          $,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max($, Et - wt)
        ]);
        a.style.minWidth = we + "px", a.style.left = Qt + "px";
      } else {
        const x = S.right - M.right, P = window.innerWidth - O.right - x, _ = window.innerWidth - Y.right - P, we = Y.width + _, wt = Math.max(we, S.width), Et = window.innerWidth - $, Qt = Jo(P, [
          $,
          Math.max($, Et - wt)
        ]);
        a.style.minWidth = we + "px", a.style.right = Qt + "px";
      }
      const R = h(), k = window.innerHeight - $ * 2, y = g.scrollHeight, G = window.getComputedStyle(s), j = parseInt(G.borderTopWidth, 10), F = parseInt(G.paddingTop, 10), K = parseInt(G.borderBottomWidth, 10), v = parseInt(G.paddingBottom, 10), J = j + F + y + v + K, V = Math.min(I.offsetHeight * 5, J), fe = window.getComputedStyle(g), Je = parseInt(fe.paddingTop, 10), be = parseInt(fe.paddingBottom, 10), le = Y.top + Y.height / 2 - $, De = k - le, Be = I.offsetHeight / 2, q = I.offsetTop + Be, H = j + F + q, T = J - H;
      if (H <= le) {
        const x = R.length > 0 && I === R[R.length - 1].ref.current;
        a.style.bottom = "0px";
        const P = s.clientHeight - g.offsetTop - g.offsetHeight, _ = Math.max(
          De,
          Be + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (x ? be : 0) + P + K
        ), we = H + _;
        a.style.height = we + "px";
      } else {
        const x = R.length > 0 && I === R[0].ref.current;
        a.style.top = "0px";
        const _ = Math.max(
          le,
          j + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (x ? Je : 0) + Be
        ) + T;
        a.style.height = _ + "px", g.scrollTop = H - le + g.offsetTop;
      }
      a.style.margin = `${$}px 0`, a.style.minHeight = V + "px", a.style.maxHeight = k + "px", n?.(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    h,
    i.trigger,
    i.valueNode,
    a,
    s,
    g,
    I,
    f,
    i.dir,
    n
  ]);
  N(() => w(), [w]);
  const [E, Q] = l.useState();
  N(() => {
    s && Q(window.getComputedStyle(s).zIndex);
  }, [s]);
  const D = l.useCallback(
    (Y) => {
      Y && p.current === !0 && (w(), B?.(), p.current = !1);
    },
    [w, B]
  );
  return /* @__PURE__ */ d(
    pl,
    {
      scope: o,
      contentWrapper: a,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: D,
      children: /* @__PURE__ */ d(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: E
          },
          children: /* @__PURE__ */ d(
            W.div,
            {
              ...r,
              ref: C,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
Tn.displayName = hl;
var Il = "SelectPopperPosition", xt = l.forwardRef((e, t) => {
  const {
    __scopeSelect: o,
    align: n = "start",
    collisionPadding: r = $,
    ...i
  } = e, A = pt(o);
  return /* @__PURE__ */ d(
    Kn,
    {
      ...A,
      ...i,
      ref: t,
      align: n,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
xt.displayName = Il;
var [pl, go] = ke(qe, {}), Zt = "SelectViewport", uo = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, nonce: n, ...r } = e, i = Ie(Zt, o), A = go(Zt, o), a = L(t, i.onViewportChange), c = l.useRef(0);
    return /* @__PURE__ */ Z(He, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ d(ht.Slot, { scope: o, children: /* @__PURE__ */ d(
        W.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: U(r.onScroll, (s) => {
            const u = s.currentTarget, { contentWrapper: C, shouldExpandOnScrollRef: h } = A;
            if (h?.current && C) {
              const m = Math.abs(c.current - u.scrollTop);
              if (m > 0) {
                const p = window.innerHeight - $ * 2, g = parseFloat(C.style.minHeight), I = parseFloat(C.style.height), f = Math.max(g, I);
                if (f < p) {
                  const B = f + m, w = Math.min(p, B), E = B - w;
                  C.style.height = w + "px", C.style.bottom === "0px" && (u.scrollTop = E > 0 ? E : 0, C.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
uo.displayName = Zt;
var Vn = "SelectGroup", [fl, Bl] = ke(Vn), Co = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e, r = st();
    return /* @__PURE__ */ d(fl, { scope: o, id: r, children: /* @__PURE__ */ d(W.div, { role: "group", "aria-labelledby": r, ...n, ref: t }) });
  }
);
Co.displayName = Vn;
var zn = "SelectLabel", mo = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e, r = Bl(zn, o);
    return /* @__PURE__ */ d(W.div, { id: r.id, ...n, ref: t });
  }
);
mo.displayName = zn;
var at = "SelectItem", [wl, Xn] = ke(at), ho = l.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: o,
      value: n,
      disabled: r = !1,
      textValue: i,
      ...A
    } = e, a = he(at, o), c = Ie(at, o), s = a.value === n, [u, C] = l.useState(i ?? ""), [h, m] = l.useState(!1), p = L(
      t,
      (B) => c.itemRefCallback?.(B, n, r)
    ), g = st(), I = l.useRef("touch"), f = () => {
      r || (a.onValueChange(n), a.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ d(
      wl,
      {
        scope: o,
        value: n,
        disabled: r,
        textId: g,
        isSelected: s,
        onItemTextChange: l.useCallback((B) => {
          C((w) => w || (B?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ d(
          ht.ItemSlot,
          {
            scope: o,
            value: n,
            disabled: r,
            textValue: u,
            children: /* @__PURE__ */ d(
              W.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": s && h,
                "data-state": s ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...A,
                ref: p,
                onFocus: U(A.onFocus, () => m(!0)),
                onBlur: U(A.onBlur, () => m(!1)),
                onClick: U(A.onClick, () => {
                  I.current !== "mouse" && f();
                }),
                onPointerUp: U(A.onPointerUp, () => {
                  I.current === "mouse" && f();
                }),
                onPointerDown: U(A.onPointerDown, (B) => {
                  I.current = B.pointerType;
                }),
                onPointerMove: U(A.onPointerMove, (B) => {
                  I.current = B.pointerType, r ? c.onItemLeave?.() : I.current === "mouse" && B.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: U(A.onPointerLeave, (B) => {
                  B.currentTarget === document.activeElement && c.onItemLeave?.();
                }),
                onKeyDown: U(A.onKeyDown, (B) => {
                  c.searchRef?.current !== "" && B.key === " " || (Al.includes(B.key) && f(), B.key === " " && B.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ho.displayName = at;
var Ue = "SelectItemText", Io = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, className: n, style: r, ...i } = e, A = he(Ue, o), a = Ie(Ue, o), c = Xn(Ue, o), s = gl(Ue, o), [u, C] = l.useState(null), h = L(
      t,
      (f) => C(f),
      c.onItemTextChange,
      (f) => a.itemTextRefCallback?.(f, c.value, c.disabled)
    ), m = u?.textContent, p = l.useMemo(
      () => /* @__PURE__ */ d("option", { value: c.value, disabled: c.disabled, children: m }, c.value),
      [c.disabled, c.value, m]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: I } = s;
    return N(() => (g(p), () => I(p)), [g, I, p]), /* @__PURE__ */ Z(He, { children: [
      /* @__PURE__ */ d(W.span, { id: c.textId, ...i, ref: h }),
      c.isSelected && A.valueNode && !A.valueNodeHasChildren ? lt.createPortal(i.children, A.valueNode) : null
    ] });
  }
);
Io.displayName = Ue;
var _n = "SelectItemIndicator", po = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e;
    return Xn(_n, o).isSelected ? /* @__PURE__ */ d(W.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
po.displayName = _n;
var Wt = "SelectScrollUpButton", fo = l.forwardRef((e, t) => {
  const o = Ie(Wt, e.__scopeSelect), n = go(Wt, e.__scopeSelect), [r, i] = l.useState(!1), A = L(t, n.onScrollButtonChange);
  return N(() => {
    if (o.viewport && o.isPositioned) {
      let a = function() {
        const s = c.scrollTop > 0;
        i(s);
      };
      const c = o.viewport;
      return a(), c.addEventListener("scroll", a), () => c.removeEventListener("scroll", a);
    }
  }, [o.viewport, o.isPositioned]), r ? /* @__PURE__ */ d(
    $n,
    {
      ...e,
      ref: A,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: c } = o;
        a && c && (a.scrollTop = a.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
fo.displayName = Wt;
var jt = "SelectScrollDownButton", Bo = l.forwardRef((e, t) => {
  const o = Ie(jt, e.__scopeSelect), n = go(jt, e.__scopeSelect), [r, i] = l.useState(!1), A = L(t, n.onScrollButtonChange);
  return N(() => {
    if (o.viewport && o.isPositioned) {
      let a = function() {
        const s = c.scrollHeight - c.clientHeight, u = Math.ceil(c.scrollTop) < s;
        i(u);
      };
      const c = o.viewport;
      return a(), c.addEventListener("scroll", a), () => c.removeEventListener("scroll", a);
    }
  }, [o.viewport, o.isPositioned]), r ? /* @__PURE__ */ d(
    $n,
    {
      ...e,
      ref: A,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: c } = o;
        a && c && (a.scrollTop = a.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
Bo.displayName = jt;
var $n = l.forwardRef((e, t) => {
  const { __scopeSelect: o, onAutoScroll: n, ...r } = e, i = Ie("SelectScrollButton", o), A = l.useRef(null), a = It(o), c = l.useCallback(() => {
    A.current !== null && (window.clearInterval(A.current), A.current = null);
  }, []);
  return l.useEffect(() => () => c(), [c]), N(() => {
    a().find((u) => u.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ d(
    W.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: U(r.onPointerDown, () => {
        A.current === null && (A.current = window.setInterval(n, 50));
      }),
      onPointerMove: U(r.onPointerMove, () => {
        i.onItemLeave?.(), A.current === null && (A.current = window.setInterval(n, 50));
      }),
      onPointerLeave: U(r.onPointerLeave, () => {
        c();
      })
    }
  );
}), El = "SelectSeparator", wo = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e;
    return /* @__PURE__ */ d(W.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
wo.displayName = El;
var Ht = "SelectArrow", Eo = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e, r = pt(o), i = he(Ht, o), A = Ie(Ht, o);
    return i.open && A.position === "popper" ? /* @__PURE__ */ d(yn, { ...r, ...n, ref: t }) : null;
  }
);
Eo.displayName = Ht;
var Ql = "SelectBubbleInput", er = l.forwardRef(
  ({ __scopeSelect: e, value: t, ...o }, n) => {
    const r = l.useRef(null), i = L(n, r), A = ma(t);
    return l.useEffect(() => {
      const a = r.current;
      if (!a) return;
      const c = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (A !== t && u) {
        const C = new Event("change", { bubbles: !0 });
        u.call(a, t), a.dispatchEvent(C);
      }
    }, [A, t]), /* @__PURE__ */ d(
      W.select,
      {
        ...o,
        style: { ...Rn, ...o.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
er.displayName = Ql;
function tr(e) {
  return e === "" || e === void 0;
}
function or(e) {
  const t = Ee(e), o = l.useRef(""), n = l.useRef(0), r = l.useCallback(
    (A) => {
      const a = o.current + A;
      t(a), function c(s) {
        o.current = s, window.clearTimeout(n.current), s !== "" && (n.current = window.setTimeout(() => c(""), 1e3));
      }(a);
    },
    [t]
  ), i = l.useCallback(() => {
    o.current = "", window.clearTimeout(n.current);
  }, []);
  return l.useEffect(() => () => window.clearTimeout(n.current), []), [o, r, i];
}
function nr(e, t, o) {
  const r = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, i = o ? e.indexOf(o) : -1;
  let A = Yl(e, Math.max(i, 0));
  r.length === 1 && (A = A.filter((s) => s !== o));
  const c = A.find(
    (s) => s.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== o ? c : void 0;
}
function Yl(e, t) {
  return e.map((o, n) => e[(t + n) % e.length]);
}
var ql = Ao, rr = ao, Dl = lo, vl = ft, ir = co, Ar = so, ar = uo, lr = Co, cr = mo, sr = ho, gr = Io, ur = po, Sl = fo, Fl = Bo, Gl = wo, Ol = Eo;
const Ml = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arrow: Ol,
  Content: Ar,
  Group: lr,
  Icon: vl,
  Item: sr,
  ItemIndicator: ur,
  ItemText: gr,
  Label: cr,
  Portal: ir,
  Root: ql,
  ScrollDownButton: Fl,
  ScrollUpButton: Sl,
  Select: Ao,
  SelectArrow: Eo,
  SelectContent: so,
  SelectGroup: Co,
  SelectIcon: ft,
  SelectItem: ho,
  SelectItemIndicator: po,
  SelectItemText: Io,
  SelectLabel: mo,
  SelectPortal: co,
  SelectScrollDownButton: Bo,
  SelectScrollUpButton: fo,
  SelectSeparator: wo,
  SelectTrigger: ao,
  SelectValue: lo,
  SelectViewport: uo,
  Separator: Gl,
  Trigger: rr,
  Value: Dl,
  Viewport: ar,
  createSelectScope: ll
}, Symbol.toStringTag, { value: "Module" })), Kl = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_17_2062)" }, /* @__PURE__ */ l.createElement("path", { d: "M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z" }))), yl = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_17_4631)" }, /* @__PURE__ */ l.createElement("path", { d: "M9.00016 16.17L4.83016 12L3.41016 13.41L9.00016 19L21.0002 6.99997L19.5902 5.58997L9.00016 16.17Z" }))), Rl = `
  inline-flex items-center justify-between flex-1
  bg-ll-background rounded-sm border
  py-1 pr-2 pl-3 min-w-[120px]
  data-[size=medium]:text-ll-font-size-p data-[size=medium]:h-8
  data-[size=large]:text-ll-font-size-h6 data-[size=large]:h-10
`, kl = `
  overflow-hidden bg-ll-background rounded-sm shadow-md
  z-10 min-w-[120px]
  data-[size=medium]:text-ll-font-size-p
  data-[size=large]:text-ll-font-size-h6
`, Jl = `
  font-sans font-inherit py-1 pr-8 pl-6 outline-none
  relative rounded-sm cursor-default text-ll-on-surface-variant1

  data-[highlighted]:[&:not([data-variant="light"])]:bg-ll-primary
  data-[highlighted]:[&:not([data-variant="light"])]:text-ll-on-primary

  // Special color between now and design system
  data-[highlighted]:[&:not([data-variant="dark"])]:bg-[#EBF5F7]
  data-[highlighted]:[&:not([data-variant="dark"])]:text-ll-on-surface
  `, bl = "font-inherit p-0", Ul = `
  absolute left-0 bottom-0
  inline-flex justify-center items-center
  h-full w-6
`, xl = ({ size: e = "medium", children: t, ...o }) => /* @__PURE__ */ Z(rr, { className: Rl, "data-size": e, ...o, children: [
  t,
  /* @__PURE__ */ d(ft, { children: /* @__PURE__ */ d(Pt, { SVGElement: Kl, fill: ue["--ll-color-on-background-variant1"] }) })
] }), Zl = ({ size: e = "medium", children: t, ...o }) => /* @__PURE__ */ d(Ar, { className: kl, "data-size": e, ...o, children: /* @__PURE__ */ d(ar, { className: bl, children: t }) }), Wl = ({ variant: e = "dark", children: t, ...o }) => /* @__PURE__ */ Z(sr, { className: Jl, "data-variant": e, ...o, children: [
  /* @__PURE__ */ d(gr, { children: t }),
  /* @__PURE__ */ d(ur, { className: Ul, children: /* @__PURE__ */ d(Pt, { SVGElement: yl, fill: "currentColor", height: 12, width: 12 }) })
] }), jl = () => /* @__PURE__ */ d(ir, {}), Hl = ({ children: e, label: t, ...o }) => /* @__PURE__ */ Z(lr, { ...o, children: [
  /* @__PURE__ */ d(cr, { children: t }),
  e
] }), { Root: Pl } = Ml, Tc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content: Zl,
  Group: Hl,
  Item: Wl,
  Portal: jl,
  Root: Pl,
  Trigger: xl
}, Symbol.toStringTag, { value: "Module" }));
function Ll(e, t) {
  return l.useReducer((o, n) => t[o][n] ?? o, e);
}
var Qo = (e) => {
  const { present: t, children: o } = e, n = Nl(t), r = typeof o == "function" ? o({ present: n.isPresent }) : l.Children.only(o), i = L(n.ref, Tl(r));
  return typeof o == "function" || n.isPresent ? l.cloneElement(r, { ref: i }) : null;
};
Qo.displayName = "Presence";
function Nl(e) {
  const [t, o] = l.useState(), n = l.useRef(null), r = l.useRef(e), i = l.useRef("none"), A = e ? "mounted" : "unmounted", [a, c] = Ll(A, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return l.useEffect(() => {
    const s = _e(n.current);
    i.current = a === "mounted" ? s : "none";
  }, [a]), N(() => {
    const s = n.current, u = r.current;
    if (u !== e) {
      const h = i.current, m = _e(s);
      e ? c("MOUNT") : m === "none" || s?.display === "none" ? c("UNMOUNT") : c(u && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, c]), N(() => {
    if (t) {
      let s;
      const u = t.ownerDocument.defaultView ?? window, C = (m) => {
        const g = _e(n.current).includes(m.animationName);
        if (m.target === t && g && (c("ANIMATION_END"), !r.current)) {
          const I = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", s = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = I);
          });
        }
      }, h = (m) => {
        m.target === t && (i.current = _e(n.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", C), t.addEventListener("animationend", C), () => {
        u.clearTimeout(s), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", C), t.removeEventListener("animationend", C);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: l.useCallback((s) => {
      n.current = s ? getComputedStyle(s) : null, o(s);
    }, [])
  };
}
function _e(e) {
  return e?.animationName || "none";
}
function Tl(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var Bt = "Popover", [Cr, Vl] = ct(Bt, [
  dt
]), Le = dt(), [zl, pe] = Cr(Bt), Yo = (e) => {
  const {
    __scopePopover: t,
    children: o,
    open: n,
    defaultOpen: r,
    onOpenChange: i,
    modal: A = !1
  } = e, a = Le(t), c = l.useRef(null), [s, u] = l.useState(!1), [C, h] = bt({
    prop: n,
    defaultProp: r ?? !1,
    onChange: i,
    caller: Bt
  });
  return /* @__PURE__ */ d(Mn, { ...a, children: /* @__PURE__ */ d(
    zl,
    {
      scope: t,
      contentId: st(),
      triggerRef: c,
      open: C,
      onOpenChange: h,
      onOpenToggle: l.useCallback(() => h((m) => !m), [h]),
      hasCustomAnchor: s,
      onCustomAnchorAdd: l.useCallback(() => u(!0), []),
      onCustomAnchorRemove: l.useCallback(() => u(!1), []),
      modal: A,
      children: o
    }
  ) });
};
Yo.displayName = Bt;
var dr = "PopoverAnchor", qo = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = pe(dr, o), i = Le(o), { onCustomAnchorAdd: A, onCustomAnchorRemove: a } = r;
    return l.useEffect(() => (A(), () => a()), [A, a]), /* @__PURE__ */ d(no, { ...i, ...n, ref: t });
  }
);
qo.displayName = dr;
var mr = "PopoverTrigger", Do = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = pe(mr, o), i = Le(o), A = L(t, r.triggerRef), a = /* @__PURE__ */ d(
      W.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": pr(r.open),
        ...n,
        ref: A,
        onClick: U(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? a : /* @__PURE__ */ d(no, { asChild: !0, ...i, children: a });
  }
);
Do.displayName = mr;
var vo = "PopoverPortal", [Xl, _l] = Cr(vo, {
  forceMount: void 0
}), So = (e) => {
  const { __scopePopover: t, forceMount: o, children: n, container: r } = e, i = pe(vo, t);
  return /* @__PURE__ */ d(Xl, { scope: t, forceMount: o, children: /* @__PURE__ */ d(Qo, { present: o || i.open, children: /* @__PURE__ */ d(ro, { asChild: !0, container: r, children: n }) }) });
};
So.displayName = vo;
var Ke = "PopoverContent", Fo = l.forwardRef(
  (e, t) => {
    const o = _l(Ke, e.__scopePopover), { forceMount: n = o.forceMount, ...r } = e, i = pe(Ke, e.__scopePopover);
    return /* @__PURE__ */ d(Qo, { present: n || i.open, children: i.modal ? /* @__PURE__ */ d(ec, { ...r, ref: t }) : /* @__PURE__ */ d(tc, { ...r, ref: t }) });
  }
);
Fo.displayName = Ke;
var $l = /* @__PURE__ */ Ze("PopoverContent.RemoveScroll"), ec = l.forwardRef(
  (e, t) => {
    const o = pe(Ke, e.__scopePopover), n = l.useRef(null), r = L(t, n), i = l.useRef(!1);
    return l.useEffect(() => {
      const A = n.current;
      if (A) return Jn(A);
    }, []), /* @__PURE__ */ d(io, { as: $l, allowPinchZoom: !0, children: /* @__PURE__ */ d(
      hr,
      {
        ...e,
        ref: r,
        trapFocus: o.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: U(e.onCloseAutoFocus, (A) => {
          A.preventDefault(), i.current || o.triggerRef.current?.focus();
        }),
        onPointerDownOutside: U(
          e.onPointerDownOutside,
          (A) => {
            const a = A.detail.originalEvent, c = a.button === 0 && a.ctrlKey === !0, s = a.button === 2 || c;
            i.current = s;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: U(
          e.onFocusOutside,
          (A) => A.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), tc = l.forwardRef(
  (e, t) => {
    const o = pe(Ke, e.__scopePopover), n = l.useRef(!1), r = l.useRef(!1);
    return /* @__PURE__ */ d(
      hr,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (n.current || o.triggerRef.current?.focus(), i.preventDefault()), n.current = !1, r.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const A = i.target;
          o.triggerRef.current?.contains(A) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && r.current && i.preventDefault();
        }
      }
    );
  }
), hr = l.forwardRef(
  (e, t) => {
    const {
      __scopePopover: o,
      trapFocus: n,
      onOpenAutoFocus: r,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: A,
      onEscapeKeyDown: a,
      onPointerDownOutside: c,
      onFocusOutside: s,
      onInteractOutside: u,
      ...C
    } = e, h = pe(Ke, o), m = Le(o);
    return gn(), /* @__PURE__ */ d(
      Nt,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: r,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ d(
          Lt,
          {
            asChild: !0,
            disableOutsidePointerEvents: A,
            onInteractOutside: u,
            onEscapeKeyDown: a,
            onPointerDownOutside: c,
            onFocusOutside: s,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ d(
              Kn,
              {
                "data-state": pr(h.open),
                role: "dialog",
                id: h.contentId,
                ...m,
                ...C,
                ref: t,
                style: {
                  ...C.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Ir = "PopoverClose", Go = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = pe(Ir, o);
    return /* @__PURE__ */ d(
      W.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: U(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
Go.displayName = Ir;
var oc = "PopoverArrow", Oo = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = Le(o);
    return /* @__PURE__ */ d(yn, { ...r, ...n, ref: t });
  }
);
Oo.displayName = oc;
function pr(e) {
  return e ? "open" : "closed";
}
var nc = Yo, rc = qo, fr = Do, ic = So, Br = Fo, Ac = Go, wr = Oo;
const ac = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Anchor: rc,
  Arrow: wr,
  Close: Ac,
  Content: Br,
  Popover: Yo,
  PopoverAnchor: qo,
  PopoverArrow: Oo,
  PopoverClose: Go,
  PopoverContent: Fo,
  PopoverPortal: So,
  PopoverTrigger: Do,
  Portal: ic,
  Root: nc,
  Trigger: fr,
  createPopoverScope: Vl
}, Symbol.toStringTag, { value: "Module" })), lc = "bg-none border-none p-0", cc = "p-3 bg-ll-background shadow-md rounded-sm w-60 z-20", sc = "fill-ll-background shadow-lg", { Root: gc, Portal: uc } = ac, Cc = ({
  side: e,
  children: t,
  sideOffset: o = yo * 2,
  collisionPadding: n = yo * 2
}) => /* @__PURE__ */ d(uc, { children: /* @__PURE__ */ Z(
  Br,
  {
    side: e,
    className: cc,
    sideOffset: o,
    collisionPadding: n,
    children: [
      /* @__PURE__ */ d(wr, { className: sc }),
      t
    ]
  }
) }), dc = ({ children: e }) => /* @__PURE__ */ d(fr, { className: lc, children: e }), Vc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content: Cc,
  Root: gc,
  Trigger: dc
}, Symbol.toStringTag, { value: "Module" })), Er = ie.createContext({}), Mo = () => Kr(Er), mc = `
  relative aspect-square rounded-full flex items-center justify-center overflow-hidden
`, hc = `
  bg-ll-surface rounded-full w-[70%] h-[70%]
  flex items-center justify-center absolute
`, Ic = `
  flex items-center justify-center
  w-full h-full

  [&>svg]:w-1/2
  [&>svg]:w-1/2
  [&>svg>path]:fill-ll-primary
`, Qr = ({ className: e }) => {
  const { data: t, colors: o, icon: n } = Mo(), r = t.reduce((A, a) => A + a, 0), i = xe(
    () => t.map((A, a) => {
      const s = A / r * 100 > 50, C = t.slice(0, a).reduce((I, f) => I + f, 0) / r * 360, h = A / r * 360, m = s ? "-100%" : "0%", p = s ? "200%" : "100%", g = `polygon(${m} ${m}, ${p} ${m}, ${p} ${p}, ${m} ${p})`;
      return /* @__PURE__ */ d(
        "div",
        {
          className: "ll-donut-segment",
          style: {
            "--ll-chart-donut-segment-clip-path": g,
            "--ll-chart-donut-segment-bg": o?.[a] ?? "#000",
            "--ll-chart-donut-segment-degrees": C,
            "--ll-chart-donut-segment-before-degrees": h,
            "--ll-chart-donut-segment-opacity": s ? 1 : 0
          }
        },
        `segment-${a}`
      );
    }),
    [t, o]
  );
  return /* @__PURE__ */ Z("div", { className: mc, children: [
    i,
    /* @__PURE__ */ d("div", { className: hc, children: /* @__PURE__ */ d("div", { className: Ic, children: n }) })
  ] });
}, pc = "list-none p-0", fc = "flex items-center", Bc = "w-3 h-3 rounded mr-2.5", Yr = () => {
  const { labels: e, colors: t } = Mo();
  return /* @__PURE__ */ d("ul", { className: pc, children: e.map((o, n) => /* @__PURE__ */ Z("li", { className: fc, children: [
    /* @__PURE__ */ d(
      "div",
      {
        className: Bc,
        style: {
          backgroundColor: t?.[n] || "#000"
        }
      }
    ),
    /* @__PURE__ */ d(se, { noMargin: !0, lineClamp: 1, variant: "caption1", children: o })
  ] }, o)) });
}, wc = `
  h-full w-full overflow-hidden bg-ll-surface
  rounded-md p-3 flex flex-col
`, Ec = "h-[6%] min-h-5", Qc = "grow mx-0 my-2 grid gap-y-1", Yc = `
  border-t border-ll-placeholder border-solid
  h-[6%] min-h-3 w-[calc(100%-165px)]
  ml-[140px] grid grid-cols-3
`, qc = `
  grid grid-rows-1 grid-cols-[140px_calc(100%-165px)]
  gap-y-1 items-center
`, Dc = `
  relative py-0.5 px-2.5 h-full
  flex justify-start items-center
`, vc = `
  z-10 flex items-center justify-center
  h-full w-10 absolute top-0
`, Sc = `
  bg-ll-primary rounded-r-md inline-block h-full absolute top-0 bottom-0 left-0
`, Fc = ({ className: e }) => {
  const { title: t, labels: o, data: n, unit: r } = Mo(), i = xe(() => {
    if (n)
      return [...n].sort((c, s) => c - s).reverse()[0];
  }, [n]), A = xe(() => !r || !i ? 100 : Math.ceil(i / 10) * 10, [i, r]), a = xe(
    () => n.map((c, s) => ({
      label: o[s],
      value: c,
      width: Math.round(c * 100 / A)
    })),
    [A, n, o]
  );
  return /* @__PURE__ */ Z("div", { className: wc, children: [
    /* @__PURE__ */ d("div", { className: Ec, children: /* @__PURE__ */ d(se, { variant: "p", noMargin: !0, weight: "--ll-font-weight-bold", children: `${t} (${r})` }) }),
    /* @__PURE__ */ d("div", { className: Qc, children: a.map((c) => /* @__PURE__ */ Z("div", { className: qc, children: [
      c.label !== "0" && /* @__PURE__ */ d(se, { noMargin: !0, variant: "caption2", children: c.label }),
      /* @__PURE__ */ Z("div", { className: Dc, children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: vc,
            style: {
              left: `${c.width}%`
            },
            children: /* @__PURE__ */ Z(se, { noMargin: !0, align: "center", color: "--ll-color-on-background", variant: "caption2", children: [
              c.value,
              r
            ] })
          }
        ),
        /* @__PURE__ */ d(
          "span",
          {
            className: Sc,
            style: {
              width: `${c.width}%`
            }
          }
        )
      ] })
    ] }, c.label)) }),
    /* @__PURE__ */ Z("div", { className: Yc, children: [
      /* @__PURE__ */ d(se, { noMargin: !0, variant: "caption2", color: "--ll-color-on-background", children: "0" }),
      /* @__PURE__ */ d(se, { noMargin: !0, variant: "caption2", align: "center", color: "--ll-color-on-background", children: `${A / 2}${r}` }),
      /* @__PURE__ */ d(se, { noMargin: !0, variant: "caption2", align: "right", color: "--ll-color-on-background", children: `${A}${r}` })
    ] })
  ] });
}, Gc = [
  "rgb(0, 188,202)",
  "rgb(208,232,233)",
  "rgb(243,209,130)",
  "rgb(255,116,16)",
  "rgb(52,65,181)",
  "rgb(151,184,126)",
  "rgb(0,132,145)",
  "rgb(62,49,91)"
], qr = (e) => /* @__PURE__ */ d(Er.Provider, { value: { ...e, colors: e.colors ?? Gc }, children: e.children }), zc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BarChart: Fc,
  Donut: Qr,
  Legend: Yr,
  Root: qr
}, Symbol.toStringTag, { value: "Module" })), Oc = `
  w-full h-full
  overflow-hidden
  bg-ll-surface
  font-sans
  rounded-md
  p-3
`, Mc = `
  mb-2
`, Kc = `
  items-center
  h-[80%]
  overflow-hidden
  my-0 mx-auto
  w-[90%] max-w-[380px] 
  flex flex-row
  justify-between
`, yc = `
  w-[35%] md:w-[45%]
`, Xc = ({ title: e, labels: t, data: o, icon: n }) => /* @__PURE__ */ Z("div", { className: Oc, children: [
  /* @__PURE__ */ d("div", { className: Mc, children: /* @__PURE__ */ d(se, { variant: "p", noMargin: !0, weight: "--ll-font-weight-bold", children: e }) }),
  /* @__PURE__ */ d(qr, { data: o, labels: t, icon: n, children: /* @__PURE__ */ Z("div", { className: Kc, children: [
    /* @__PURE__ */ d("div", { className: yc, children: /* @__PURE__ */ d(Qr, {}) }),
    /* @__PURE__ */ d(He, { children: /* @__PURE__ */ d(Yr, {}) })
  ] }) })
] }), Dr = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" })), vr = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" })), Rc = ({ options: e }) => /* @__PURE__ */ d(
  Ri,
  {
    SVGElement: e.style === "house" ? Dr : vr,
    size: e.size || "large",
    backgroundColor: ue["--ll-color-primary"],
    backgroundColorHighlight: ue["--ll-color-primary-variant1"],
    renderForPrint: e.renderForPrint
  }
), kc = ({ options: e }) => /* @__PURE__ */ Z("svg", { viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ Z("linearGradient", { id: "gradient", gradientTransform: "rotate(90)", children: [
    /* @__PURE__ */ d("stop", { offset: "20%", style: { stopColor: "#0d9488" } }),
    /* @__PURE__ */ d("stop", { offset: "80%", style: { stopColor: "#0f766e" } })
  ] }) }),
  /* @__PURE__ */ d("circle", { cx: "18", cy: "18", r: "16.25", stroke: "white", strokeWidth: "1.75", fill: "url(#gradient)" }),
  /* @__PURE__ */ d("svg", { fill: "white", width: "20", height: "20", x: "8", y: "8", children: e.style === "house" ? /* @__PURE__ */ d(Dr, {}) : /* @__PURE__ */ d(vr, {}) })
] }), Jc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), _c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleRoot: kc,
  Root: Rc,
  Types: Jc
}, Symbol.toStringTag, { value: "Module" }));
export {
  Pc as Alert,
  ln as Button,
  zc as Chart,
  Xc as DonutChart,
  hi as Input,
  ri as Label,
  Hc as Link,
  Nc as LoadingItem,
  ci as LoadingSpinner,
  Ri as Marker,
  _c as PinMarker,
  Vc as Popover,
  Pt as SVG,
  Tc as Select,
  Lc as Spacer,
  jc as Tag,
  se as Text,
  Wc as baseStyles,
  yo as gridUnit,
  ue as theme,
  Zc as useThemeSwitcher
};
